﻿window.agRequest = {
    GET: async function (serviceUrl, data) {
        var queryString = '';
        for (var key in data) {
            queryString = queryString + ((queryString != '' ? '&' : '') + key + '=' + data[key]);
        }
        serviceUrl += serviceUrl.indexOf('?') > -1 ? '&' : '?' + queryString;
        var request = await fetch(serviceUrl, {
            method: "GET",
            cache: "no-cache",
            headers: {
                "Content-Type": "application/json",
            }
        });

        return request.json();
    },
    POST: async function (serviceUrl, data) {
        var formData = new URLSearchParams();
        for (var key in data) {
            formData.append(key, data[key]);
        }
        var request = await fetch(serviceUrl, {
            method: "POST",
            cache: "no-cache",
            body: formData
        });

        return request.json();
    }
};

window.agRefresh = function () {
    
    document.body.dispatchEvent(new CustomEvent('ag.refresh'));

};

(async function () {
    async function findLazy() {
        let items = document.querySelectorAll('[ag-lazy][data-src]:not(.ag-lazy):not(.no-ag):not([data-src*="{{"])');

        items.forEach(function (item, index) {
            item.classList.add('ag-lazy');
            var action = function () {
                attachAction(item, function () {
                    document.body.removeEventListener('ag.lazy', action);
                });
            };

            document.body.addEventListener('ag.lazy', action);

            action();

        });
    }

    async function init() {

        document.body.addEventListener('ag.lazy.refresh', findLazy);

        document.body.addEventListener('ag.refresh', findLazy);

        var customEvent = new CustomEvent('ag.lazy.refresh');

        document.body.dispatchEvent(customEvent);

        document.addEventListener('scroll', function (e) {

            var customEvent = new CustomEvent('ag.lazy');

            document.body.dispatchEvent(customEvent);

        });

        var customEvent = new CustomEvent('ag.lazy');

        document.body.dispatchEvent(customEvent);

        window.agLazy = {
            refresh: function () {
                var customEvent = new CustomEvent('ag.lazy.refresh');

                document.body.dispatchEvent(customEvent);
            },
            validate: function () {
                var customEvent = new CustomEvent('ag.lazy');

                document.body.dispatchEvent(customEvent);
            }
        };

    }

    async function attachAction(item, success) {
        var blankImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
        if (await checkisInViewport(item)) {
            if (item == null) return;
            var srcUrl = await getFormattedImageUrl(item.getAttribute('data-src'), item);
            item.setAttribute('data-src', srcUrl.url);
            if (item.nodeName == 'VIDEO') item.setAttribute('src', srcUrl.url);
            else if (item.nodeName == 'OBJECT' || item.nodeName == 'AUDIO')
                item.setAttribute('src', srcUrl.url)
            else if (item.nodeName == 'IMG') {
                item.addEventListener('load', function () {
                    if (item.getAttribute('src') != blankImage)
                        item.classList.add('ag-lazy-s');
                });

                item.setAttribute('src', blankImage);

                if (srcUrl != null) {
                    if (srcUrl.size) {
                        if (srcUrl.size.width > 0)
                            item.setAttribute('width', srcUrl.size.width);
                        if (srcUrl.size.height > 0)
                            item.setAttribute('height', srcUrl.size.height);
                    }
                    item.setAttribute('src', srcUrl.url);
                }


            }
            else
                item.style['background-image'] = `url('${srcUrl.url}')`;
            success();
        }

        let options = {
            root: null,
            rootMargin: "0px",
            threshold: 0.1,
        };

        let observer = new IntersectionObserver(function () {

            console.log(item, 'View');

        }, options);

    }

    async function getFormattedImageUrl(url, item) {
        if (item == null) return null;
        var isAuto = item.hasAttribute('data-ratio-auto');
        if (isAuto || item.nodeName == 'VIDEO' || item.nodeName == 'OBJECT') return { url: url };
        var current = await getBestFitContainer(item, 16, 9, 1);
        if (current == null) return null;
        var match = /.*\?(.*?(mh|mw)\=(\d+))*/gi.exec(url);
        var additionalUrl = '';
        if (item.getAttribute('data-crop') != null) additionalUrl += '&mode=crop';
        if (url.indexOf('/') == 0 && false) {
            var projectCode = document.body.getAttribute('data-pcode');
            url = `https://cdn.datafloat.com/${projectCode}_CWS${url}`;
            console.log(url);
        }
        if (match != null) {
            return { url: url, size: current };
        } else {
            return { url: `${url}?` + (current.width > 0 ? `mw=${current.width * current.scale}` + (current.height > 0 ? '&' : '') : '') + (current.height > 0 ? `mh=${current.height * current.scale}` : '') + `${additionalUrl}`, size: current };
        }
    }

    async function getBestFitContainer(item, defaultRatioWidth, defaultRatioHeight, defaultScale) {
        if (item == null) return null;
        var current = item.getBoundingClientRect();
        var ratio = item.getAttribute('data-ratio');
        var scaleSize = item.getAttribute('data-scale');
        if (scaleSize != null) defaultScale = parseFloat(scaleSize);

        var ratioMatch = null;

        if (ratio && ratio != null && (ratioMatch = /^(?<width>[0-9\.]{1,4}):(?<height>[0-9\.]{1,4})$/gi.exec(ratio)) != null) {
            defaultRatioWidth = parseFloat(ratioMatch.groups.width);
            defaultRatioHeight = parseFloat(ratioMatch.groups.height);
            if (defaultRatioWidth == 0) defaultRatioWidth = -1;
            if (defaultRatioHeight == 0) defaultRatioHeight = -1;
        }

        var width = current.width;
        var height = current.height;
        if (item.classList.contains('ag-lazy')) {
            width = item.getAttribute("width");
            height = item.getAttribute("height");
            if (width == undefined || width == null || width == '')
                width = item.style.width;

            if (width == undefined || width == null || width == '') width = 0;
            else width = parseInt(width.replace(/[^\d]+/gi, ''));
            if (height == undefined || height == null || height == '') height = 0;
            else height = parseInt(height.replace(/[^\d]+/gi, ''));
        }



        if (width != height && ((width == undefined || height == undefined) || (height < width / defaultRatioWidth * defaultRatioHeight) || width < height / defaultRatioHeight * defaultRatioWidth)) {
            if (width > 0)
                height = width / defaultRatioWidth * defaultRatioHeight;
            else
                width = height / defaultRatioHeight * defaultRatioWidth;
        }


        if ((width > 0 || defaultRatioWidth < 0) && (height > 0 || defaultRatioHeight < 0)) {
            width = Math.floor(width);
            height = Math.floor(height);
            return { width: defaultRatioWidth < 0 ? 0 : width + (10 - (width % 10)), height: defaultRatioHeight < 0 ? 0 : height + (10 - (height % 10)), scale: defaultScale };
        }
        return await getBestFitContainer(item.parentElement, defaultRatioWidth, defaultRatioHeight, defaultScale);

    }

    async function mapToAutoSize(width, height) {
        return { width: width, height: height }
    }

    async function checkisInViewport(element) {
        var current = element.getBoundingClientRect();

        var body = document.body;
        var docEl = document.documentElement;

        var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
        var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

        var clientTop = docEl.clientTop || body.clientTop || 0;
        var clientLeft = docEl.clientLeft || body.clientLeft || 0;

        var elementTop = current.top + scrollTop - clientTop;
        var elementBottom = current.bottom + scrollTop - clientTop;

        let viewportTop = scrollTop;
        let viewportBottom = viewportTop + window.innerHeight;

        return elementBottom > viewportTop && elementTop < viewportBottom;
    }


    document.addEventListener('DOMContentLoaded', init);



})();

(async function () {

    var isSynced = false;

    document.body.addEventListener('ag.user.in', function (e) {
        set(e.detail);        
    });

    document.body.addEventListener('ag.agent.in', function (e) {

        setAgent(e.detail);
        document.body.dispatchEvent(new CustomEvent('ag.sync.autoupdate'));
    });

    document.body.addEventListener('ag.user.out', function (e) {

        set(null);

    });

    document.body.addEventListener('ag.agent.out', function (e) {

        setAgent(null);

    });

    async function get() {
        var current = null;
        if (window.localStorage.getItem('AGUSER') != null) {
            current = JSON.parse(window.localStorage.getItem('AGUSER'))
        }
        if (current != null && document.body.classList.contains('restricted-listing')) {
            document.body.classList.remove('restricted-listing');
        }
        return current;
    }

    async function getAgent() {
        var current = null;
        if (window.localStorage.getItem('AGAGENT') != null) {
            current = JSON.parse(window.localStorage.getItem('AGAGENT'))
        }
        return current;
    }

    async function set(user) {
        if (user == null) {
            window.localStorage.removeItem('AGUSER');
            document.body.dispatchEvent(new CustomEvent('ag.user.clear'));
        }
        else {
            if (user.Guid) {
                var localUser = {};
                localUser.Guid = user.Guid;
                localUser.Name = user.Name;
                localUser.FirstName = user.FirstName;
                localUser.LastName = user.LastName;
                localUser.Email = user.Email;
                localUser.Phone = user.Phone;
                localUser.MobilePhone = user.MobilePhone;
                window.localStorage.setItem('AGUSER', JSON.stringify(localUser));
                update();
            }
        }
    }

    async function setAgent(agent) {
        if (agent == null) {
            window.localStorage.removeItem('AGAGENT');
            document.body.dispatchEvent(new CustomEvent('ag.agent.clear'));
        }
        else {
            if (agent.Guid) {
                var localUser = {};
                localUser.Guid = agent.Guid;
                localUser.Name = agent.Name;
                localUser.Role = agent.Role;
                window.localStorage.setItem('AGAGENT', JSON.stringify(localUser));
                update();
            }
        }
    }

    async function update() {
        render();
    }

    async function render() {
        var userStates = document.querySelectorAll('[ag-user]');      
        userStates.forEach(function (item, i) { renderStates(item, i); });
    }

    async function renderStates(item, i) {

        item.classList.add('is-applied');
        var currentState = item.cloneNode(true);
        var current = await get();
        if (current != null) {
            initPropertyCollection();
            var logginedNode = await getLoginedItem(current, i);
            item.parentElement.insertBefore(logginedNode, item);
            item.remove();
            if (!(typeof (componentHandler) == 'undefined')) {
                componentHandler.upgradeDom();
            }
            setForms(current);
        }
    }
   
    async function initPropertyCollection() {
        if (isSynced) {
            updatePropertyCollection();
        } else {
            document.body.addEventListener('ag.sync.verified.contact', function () {
                updatePropertyCollection();
            });
        }
        document.body.addEventListener('ag.lazy.refresh', function () {
            updatePropertyCollection();
        });
        document.body.addEventListener('ag.user.refresh.collection', function () {
            updatePropertyCollection(true);
        });
        document.body.addEventListener('ag.user.clear.collection', function () {
            window.localStorage.removeItem('AGUSERCOLLECTION3');
        });
        document.body.addEventListener('ag.user.clear', function () {
            document.body.dispatchEvent(new CustomEvent('ag.user.clear.collection'));
        });
    }

    async function updatePropertyCollection(isForced) {
        var collectionType = 3;
        var items = await getPropertyCollection(collectionType, isForced);
        var itemsExtracted = items.Items.reduce(function (result, current) {
            return result ? [...result, ...current.Items] : [...current.Items];
        }, []);
        itemsExtracted.forEach(async function (item) {
            renderPropertyCollectionItem(item, collectionType);
        });
    }

    async function renderPropertyCollectionItem(item, type) {
        var itemDom = document.querySelectorAll('[data-perform-action-url*="pk=' + item.PK + '"][data-perform-action-url*="rt=' + item.RT + '"]');
        itemDom.forEach(async function (dom) {
            dom.setAttribute('ag-user-collection', type);
        });
    }

    async function getPropertyCollection(collectionType, isForced) {
        return new Promise(async function (resolve, reject) {
            var propertyCollection = null;
            var propertyCollectionString = isForced ? null : window.localStorage.getItem('AGUSERCOLLECTION' + collectionType);
            if (propertyCollectionString != null) {
                propertyCollection = JSON.parse(propertyCollectionString);
                resolve(propertyCollection);
                return;
            }
            propertyCollection = await window.agRequest.GET('/services/agoraClient.ashx', { type: 'USERCOLLECTION', collectionType: collectionType });
            window.localStorage.setItem('AGUSERCOLLECTION' + collectionType, JSON.stringify(propertyCollection));
            resolve(propertyCollection);
        });


    }

    async function getLoginedItem(contact, i) {
        
        var wrapper = new c('div');
        wrapper.a('ag-user', '');
        var holder = wrapper.n('a');
        holder.a('id', 'dash-boardh-'+i).a('class', 'user-logged-in mdl-button mdl-js-button mdl-js-ripple-effect')
        holder.n('i').a('class', 'aga-person');
        holder.n('b').a('class', 'no-translate').h(contact.Name);
        wrapper.n('input').a('type', 'hidden').a('id', 'CONTACT_GUID').a('value', contact.Guid);
        var options = wrapper.n('ul');
        options.a('class', 'mdl-menu mdl-menu--bottom-right mdl-js-menu atag').a('for', 'dash-boardh-' + i).a('role', 'complementary').a('aria-labelledby', 'dash-boardh-' + i);
        options.n('li').a('class', 'mdl-menu__item chipitem').n('a').h(contact.Name);
        options.n('li').a('class', 'mdl-menu__item').n('a').a('href', '/dashboard/default.aspx').h('Dashboard');
        options.n('li').a('class', 'mdl-menu__item mdl-menu__item--full-bleed-divider').a('data-modaldialog-src', '/dashboard/EditProfile.aspx').a('data-modaldialog-ajax', 'true').a('data-modaldialog', '').h('Edit Profile');
        options.n('li').a('class', 'mdl-menu__item').n('a').a('href', '/dashboard/SignOut.aspx').a('data-agora-icon', '').h('Log out').cl(function () {
            document.body.dispatchEvent(new CustomEvent('ag.user.out'));
        });
        return wrapper.node;
    }

    function setForms(user) {
        for (var key in user) {
            if (typeof (user[key]) != 'undefined')
                document.querySelectorAll('input[node="' + key + '"]').forEach(function (nodeField) {
                    nodeField.value = user[key];
                    nodeField.dispatchEvent(new CustomEvent('input'));
                });
        }        
    } 

    function c(name) {
        this.node = document.createElement(name);
        return this;
    }

    c.prototype.a = function (name, value) {
        this.node.setAttribute(name, value)
        return this;
    }

    c.prototype.n = function (name) {
        var item = new c(name);
        this.node.appendChild(item.node);
        return item;
    }

    c.prototype.h = function (text) {
        this.node.innerHTML = text;
        return this;
    }

    c.prototype.cl = function (action) {
        this.node.removeEventListener('click', action);
        this.node.addEventListener('click', action);
        return this;
    }

    function init() {
        render();
        getAgent().then(agent => {
            if (agent != null) {
                setTimeout(function () {
                    var nodeToInvoke = new c('script').a('src', 'https://unpkg.com/ibp-cdn@latest/sessiontimeout.js');
                    document.body.appendChild(nodeToInvoke.node);
                }, 10 * 60 * 1000);
            }
        });        

        document.body.addEventListener('ag.refresh', async function () {
            var current = await get();
            if (current != null)
                setForms(current);
        });
        document.body.addEventListener('ag.sync.autoupdate', async function () {
            var currentAgent = await getAgent();            
            if (currentAgent != null) {
                document.body.dispatchEvent(new CustomEvent('ag.sync.set', { detail: { agentguid: currentAgent.Guid, eventType: 'autoagent' } }));
                setTimeout(function () { document.body.dispatchEvent(new CustomEvent('ag.sync.autoupdate')); },60*1000);
            }
                
            
        });
        document.body.addEventListener('ag.sync.check', async function () {
            var current = await get();
            var currentAgent = await getAgent();
            var currentValuesString = window.localStorage.getItem('AGSYNC');            
            if (currentValuesString != null && (current != null || currentAgent != null)) {
                var currentValue = JSON.parse(currentValuesString);
                var changeRequire = false;
                if (current!=null && currentValue.ContactGuid != current.Guid) {
                    document.body.dispatchEvent(new CustomEvent('ag.sync.set', { detail: { contactguid: current.Guid, eventType: 'contact' } }));
                    changeRequire = true;
                }

                if (currentAgent != null && (currentValue.AgentGuid != currentAgent.Guid || currentValue.Role != currentAgent.Role)) {
                    document.body.dispatchEvent(new CustomEvent('ag.sync.set', { detail: { agentguid: currentAgent.Guid, agentrole: currentAgent.Role, eventType: 'agent' } }));
                    changeRequire = true;
                }

                if (changeRequire) return;
            }
            document.body.dispatchEvent(new CustomEvent('ag.sync.verified.contact'));            
            isSynced = true;
        });

        document.body.addEventListener('ag.sync.verified', async function () {
            document.body.dispatchEvent(new CustomEvent('ag.sync.verified.contact'));
            isSynced = true;
        });

        document.body.addEventListener('ag.sync.verified.agent', function () {
            window.location.reload();
        });
    }

    window.agUser = {
        collection: {
            refresh: function () {
                document.body.dispatchEvent(new CustomEvent('ag.user.refresh.collection'));
            }
        }
    };

    init();

})();

(async function () {

    async function checkForSync() {
        var currentValuesString = window.localStorage.getItem('AGSYNC');
        if (currentValuesString != null) {
            var currentValue = JSON.parse(currentValuesString);
            var updatedOn = new Date(currentValue.updatedOn);
            var currentDateTime = new Date();
            currentDateTime.setMinutes(currentDateTime.getMinutes() - 1);
            if (updatedOn > currentDateTime) {
                document.body.dispatchEvent(new CustomEvent('ag.sync.verified'));
                return;
            }
        }
        readFromServer();
    }

    async function readFromServer() {
        var dataToReview = await window.agRequest.GET('/services/agoraClient.ashx', { type: 'SYNC' });
        dataToReview.updatedOn = new Date();
        window.localStorage.setItem('AGSYNC', JSON.stringify(dataToReview));
        document.body.dispatchEvent(new CustomEvent('ag.sync.check'));
    }

    async function init() {
        document.body.addEventListener('ag.sync.set', async function (e) {
            await window.agRequest.POST('/services/agoraClient.ashx', Object.assign({ type: 'SET' }, e.detail));
            if (e.detail?.eventType)
                document.body.dispatchEvent(new CustomEvent('ag.sync.verified.' + e.detail.eventType));
        });

        document.body.addEventListener('ag.sync.invalid', async function (e) {
            document.body.dispatchEvent(new CustomEvent('ag.sync.reset'));
            window.location.reload();
        });

        checkForSync();
    }

    init();
})();

var agevent = new CustomEvent("onAgoraLoad");
document.dispatchEvent(agevent);
document.isAgoraLoaded = true;
agevent = new CustomEvent('onCssLoad');
document.dispatchEvent(agevent);
document.isCssLoaded = true;

agora(function () {
    EnableTabContents();
    openContacusForm();
    cssLoad(function () { document.body.classList.add('css-loaded'); window.dispatchEvent(new CustomEvent('resize')); });
    if (componentHandler) componentHandler.upgradeDom();

    EnableDynamicQueryList()
    //Formitting mobile phone form field      
    $('[node="MobilePhone"]').not(".disablephoneformat").formatter({
        'pattern': '({{999}}) {{999}}-{{9999}}'
    });

    // Date Formatting

    //$('[data-datemanuall]').val(new Date().toLocaleDateString('en-US'));
    $('[data-datemanuall]').formatter({
        'pattern': '{{99}}/{{99}}/{{9999}}'
    });

    // End

    $('[node="ShowingDate"]').attr('min', getFormattedDate(new Date()));
    $('[node="ShowingDate"]').attr('max', getMaxDate(new Date()));

    $('section.footer ul.mdl-mega-footer__link-list li a[href="JavaScript:Void(0);"]').each(function () {
        $(this).parent('li').addClass("mdl-cell--hide");
    });
    $('section.footer ul.mdl-mega-footer__link-list li a[href="JavaScript:Void(0)"]').each(function () {
        $(this).parent('li').addClass("mdl-cell--hide");
    });
    $('body.company.company-template .mdl-layout__drawer .mdl-navigation ul li.have-child a:not(.mdl-button)').click(function () {
        $(this).parent().children('label').trigger('click');
    });

    setInterval(function () {
        $('a[href="#"]').each(function () {
            $(this).attr('href', 'javascript:void(0)').removeAttr('target');
        });
    }, 1000);

    if (window.location.hash) {
        if (window.location.hash == '#managebanner') {
            $('[data-banner-edit]').trigger('click');
            var currentURL = window.location.href;
            window.history.replaceState(null, null, currentURL.replace('#managebanner', ''));
        }
        if (window.location.hash == '#add-testimonial') {
            $("#IwbPopUpArea").AgoraDialogModal({ ServiceUrl: '/PopUps/Testimonial/addTestimonial.aspx', ParentCss: 'testimonial', EnableAjaxHtmlLoad: true });
        }
    }

    // start tab index ----

    //try {
    //    // remove TabIndex
    //    removeTagAttibute('tabindex');
    //    // end tabindex 
    //    var _index = 1;
    //    $('input:not(:button,:hidden,:checkbox,:radio),textarea').each(function () {
    //        var OnesearchName = $(this).attr("onesearchname");
    //        if ('a[href]: not([href ^= "mailto\\:"], [href$ = "#"], [href ^= "javascript:void(0)"])') {
    //            $(this).attr("tabindex", _index);
    //            _index++;
    //        } else {
    //            $(this).attr("tabindex", "-1");
    //        } 
    //        if (OnesearchName != 'undefined' || OnesearchName != 'homePropertyFields' || OnesearchName != 'agentFields' || OnesearchName != 'propertyFields') {
    //            $(this).attr("tabindex", "-1");
    //        }
    //    });
    //} catch (err) { }

    try {
        $('div').each(function () {
            if ($(this).attr("tabindex")) {
                $(this).removeAttr("tabindex")
            }
        });
        var _index = 1;

        $('a:visible,textarea,input:not(:hidden),select,input:radio').each(function () {

            if ($(this).attr("tabindex")) {
                $(this).attr("tabindex", _index);
                _index++;
            }
            $(this).attr("tabindex", _index);
            _index++;

        });

    } catch (err) { }

    // End start tab index ----

    // ADA Complainces
    $(document).on("click", "[data-for]", function (e) {
        try {
            var _for = $(this).data('for');
            $('[for="' + _for + '"]').trigger("click");
        } catch (e) { }
    });
    // END

    $(document).on('keyup', '[node="MobilePhone"]', {}, function () {
        try {
            $(this).val($(this).val().replace(/t/gi, ''));                                   // Special Case: "t" replaced from number 
            if ($(this).closest('.mdl-js-textfield').length > 0)
                $(this).closest('.mdl-js-textfield')[0].MaterialTextfield.checkDirty();
        } catch (e) { }
    });

    EnableStickyHeader();
    cssLoad(function () { EnableFlowlessHeader(); });
    EnableDynamicContentLoad();
    EnableSearchBar();
    EnableSearchForm();
    EnableLeadForm();
    EnableSlider();
   CloseAgoraDropDownOnBodyClick();
    EnableConverter();
    EnableDemandImport();
    EnableHJNImport();
    EnableYelpImport();
    EnableAreaMapImport();
    EnableAVMControl();
    getAvmFunction();
    ReloadProperttypestate();
    EnableGoogleTagManager();
    EnableGoogleSearch();
    EnableBrytecore();

});

var ThemeManager = new Theme();
function Theme() {
    var _self = this;
    _self.Palette = function (hex) {
        return _self.PaletteGenerator(hex);
    };

    _self.PaletteGenerator = function (hex) {
        this.multiply = function (rgb1, rgb2) {
            rgb1.b = Math.floor(rgb1.b * rgb2.b / 255);
            rgb1.g = Math.floor(rgb1.g * rgb2.g / 255);
            rgb1.r = Math.floor(rgb1.r * rgb2.r / 255);
            return tinycolor('rgb ' + rgb1.r + ' ' + rgb1.g + ' ' + rgb1.b);
        };
        var baseLight = tinycolor('#ffffff');
        var baseDark = this.multiply(tinycolor(hex).toRgb(), tinycolor(hex).toRgb());
        var baseTriad = tinycolor(hex).tetrad();
        return {
            '50': tinycolor.mix(baseLight, hex, 12)
            , '100': tinycolor.mix(baseLight, hex, 30)
            , '200': tinycolor.mix(baseLight, hex, 50)
            , '300': tinycolor.mix(baseLight, hex, 70)
            , '400': tinycolor.mix(baseLight, hex, 85)
            , '500': tinycolor.mix(baseLight, hex, 100)
            , '600': tinycolor.mix(baseDark, hex, 87)
            , '700': tinycolor.mix(baseDark, hex, 70)
            , '800': tinycolor.mix(baseDark, hex, 54)
            , '900': tinycolor.mix(baseDark, hex, 25)
            , 'A100': tinycolor.mix(baseDark, baseTriad[4], 15).saturate(80).lighten(65)
            , 'A200': tinycolor.mix(baseDark, baseTriad[4], 15).saturate(80).lighten(55)
            , 'A400': tinycolor.mix(baseDark, baseTriad[4], 15).saturate(100).lighten(45)
            , 'A700': tinycolor.mix(baseDark, baseTriad[4], 15).saturate(100).lighten(40)
        };

    };
};


function getFormattedDate(date) {
    var _month = (date.getMonth() + 1);
    var monthStr = _month + '';
    var _day = date.getDate() + '';
    var _year = date.getFullYear() + '';
    return _year + '-' + monthStr.padStart(2, '0') + '-' + _day.padStart(2, '0');
}

function getMaxDate(date) {
    var date = new Date();
    var d = date.getDate();
    date.setMonth(date.getMonth() + 3);
    return getFormattedDate(date);

}

function EnableStickyHeader() {
    $(window).resize(_resize);
    //setTimeout(_resize, 800);
    _resize();
    window.homeFlashLoaded = function () {
        _resize();
    }
    if (typeof (window.homeFlashLoadedInitially) != 'undefined') {
        _resize();
    }
    function _resize() {
        if ($("body.company").length > 0) {
            var headerHeight = $("header").outerHeight();
            var windowScrollTop = $(window).scrollTop();
            if ($('.company').length > 0 && !$(".body_propertymapsearch ").length > 0) {
                windowScrollTop > 1 ? $("header:not(.open-house-registration)").addClass("collapsed slideInDown animated floating-head").removeClass("active-block") : $("header:not(.open-house-registration)").removeClass("collapsed slideInDown animated").addClass("active-block");
                windowScrollTop > 1 ? $("body").addClass("scroll") : $("body").removeClass("scroll");
                //if (!$("body.company.with-title-slider").length > 0 && !$(".body_propertymapsearch ").length > 0 && $('header').hasClass("floating-head")) { $("body.company main.mdl-layout__content").css("margin-top", headerHeight); }
                //if (!$(".body_propertymapsearch ").length > 0) { $("body.company main.mdl-layout__content").css("margin-top", headerHeight); console.log(headerHeight); }
            }
            $(window).scroll(function () {
                var windowScrollTop = $(window).scrollTop();
                if ($('.company').length > 0 && !$(".body_propertymapsearch ").length > 0) {
                    windowScrollTop > 1 ? $("header:not(.open-house-registration)").addClass("collapsed slideInDown animated floating-head").removeClass("active-block") : $("header:not(.open-house-registration)").removeClass("collapsed slideInDown animated").addClass("active-block");
                    windowScrollTop > 1 ? $("body").addClass("scroll") : $("body").removeClass("scroll");
                    //if (!$("body.company.with-title-slider").length > 0 && !$(".body_propertymapsearch ").length > 0) { $("body.company main.mdl-layout__content").css("margin-top", headerHeight); }
                    //if (!$(".body_propertymapsearch ").length > 0) { $("body.company main.mdl-layout__content").css("margin-top", headerHeight); console.log(headerHeight); }
                }
            });
        }
    }
    $(document).on("click", ".mdl-layout__drawer-btn", function () {
        $(".mdl-layout__drawer-button").trigger("click");
    });
}

function EnableFlowlessHeader() {
    var $AutoHeader = $('.agora-layout-header-auto');
    var $actualHeader = $('.agora-layout-header');
    function setHeader() {
        $AutoHeader.outerHeight($actualHeader.outerHeight());
        $('body').addClass('agora-layout-header-auto-height');
    }
    if ($AutoHeader.length > 0) {
        setHeader();
        $(window).on("load resize", function () {
            setHeader();
        });
    }
    $actualHeader.find('img.logo').load(setHeader);
}

function EnableGoogleTagManager() {
    var _tagManagerStack = [];

    function _pushEvent(event) {
        _tagManagerStack.push(event);
    }

    function _popEvent() {
        return _tagManagerStack.pop();
    }

    function _googleTagManager(params) {
        var _isDebug = window.location.host.indexOf('localhost') > -1;
        try {
            if (_isDebug) {
                console.log('GTM');
                console.log(params);
            } else {
                console.log('GTM');
                console.log(params);
                if (typeof (dataLayerSub) != 'undefined' && dataLayerSub != null) dataLayerSub.push(params);
                if (typeof (dataLayer) != 'undefined' && dataLayer != null) dataLayer.push(params);
            }
        } catch (e) { console.log(e); }
    }

    function _getGTMTagType($node) {
        if ($node.is('[data-gtm-track]')) return 2;
        else if ($node.is('[data-gtm-track-event]')) return 1;
        return 0;
    }

    function _parseToParams($node) {
        var _nodeType = _getGTMTagType($node);
        var _gtmParams = {};
        var _gtmArray = [];
        try {
            var _gtm = $node.data('gtm-track');
            var _gtmParts = _gtm.split(',');
            if (_gtmParts.length > 0) _gtmParams.event = _gtmParts[0];
            _gtmArray.push(_gtmParams.event);

            if (_gtmParts[0] == _gtmParts[1]) { _gtmParams = $.parseJSON($node.attr('data-' + _gtmParts[1].toLowerCase()).replace(/\'/gi, '"')); }
            else {
                for (var i = 1; i < _gtmParts.length; i++) {
                    try {

                        _gtmParams[_gtmParts[i]] = null;
                        var _nodeParamValue = $node.data(_gtmParts[i].toLowerCase());
                        _nodeParamValue = (_nodeParamValue[0] == '{' && _nodeParamValue[_nodeParamValue.length - 1] == '}' ? $.parseJSON(_nodeParamValue.replace(/\'/gi, '"')) : _nodeParamValue);

                        if (typeof (_nodeParamValue) != 'undefined') {
                            if ($node.is('[data-isarray]'))
                                _gtmArray.push(_nodeParamValue);
                            else
                                _gtmParams[_gtmParts[i]] = _nodeParamValue;
                        }

                    } catch (ex) { }
                }
            }
        } catch (e) { }
        return $node.is('[data-isarray]') ? _gtmArray : _gtmParams;
    }

    function _googleTagManagerTrack($node) {
        _googleTagManager(_parseToParams($node));
    }

    $(document).on('track', '[data-gtm-track]', null, function (e) {
        _googleTagManagerTrack($(this));
    });

    //Form Success Event
    $(document).on('success', '[data-request][data-gtm-track]', null, function (e) {
        $(this).trigger('track');
    });

    $(document).on('click', '[data-gtm-click][data-gtm-track]', null, function (e) {
        $(this).trigger('track');
    });

    $(document).on('gtm-track', 'body', null, function (e, data) {
        _googleTagManager(data);
    });

}

function SaveOrderXML() {
    var $sender = $("#fromorder .widget").toArray();
    var _xml = "<d>";
    for (i = 0; i < $sender.length; i++) {
        _xml = _xml + ('<Fields><WidgetFields><MasterKey><![CDATA[' + $($sender[i]).attr('data-masterkey') + ']]></MasterKey><WidgetOrder><![CDATA[' + $($sender[i]).attr('data-order') + ']]></WidgetOrder><Label><![CDATA[' + $($sender[i]).attr('data-value') + ']]></Label><WidgetStatus><![CDATA[' + $($sender[i]).attr('data-showorhide') + ']]></WidgetStatus></WidgetFields></Fields>');
    }
    _xml += '</d>';
    $.ajax({
        type: 'POST',
        url: '/services/webbuilder/agoraWidget.ashx',
        data: { fields: _xml, type: 'Form', widgetname: '' },
        dataType: 'json',
        success: function (response) {
            if (response.success == 1) {
                ShowAlert('Widget sucessfully Added.', 3000, 'alert_box', null);
                agoraClearCache(function () {
                    ClosePopup();
                    location.reload();
                });
            } else {
                ShowAlert('Something went wrong!. Please try again.', 3000, 'alert_box', null);
            }
        },
        error: function (e) {
            console.log('Error: ' + e);
        }
    });
}

function EnableSearchForm() {
    function searchActon(sender) {
        setTimeout(function () {
            var $sender = $(sender);
            var $form = $sender.closest('[data-search-form]');
            var _urlQuery = composeUrlQuery({ select: $form });
            var _rt = $form.data('search-form');
            var $sort = $('[data-sort-object="' + _rt + '"]');
            var _default = $form.data('default-search');
            var _defaultSort = $form.data('default-sort');
            if ((typeof (_default) != 'undefined' && _default != '' && _urlQuery.indexOf('/address-') == -1 && _urlQuery.indexOf('/mls-') == -1)) _urlQuery += _default;
            if ($sort.length > 0) {
                var _sortValue = $sort.val();
                _urlQuery += _sortValue != null && _sortValue != '' ? _sortValue : '';
            }
            else if (typeof (_defaultSort) != 'undefined' && _defaultSort != null && _defaultSort != '') _urlQuery += _defaultSort;
            $form.triggerHandler('search', [{ query: _urlQuery }]);
        }, 200);
    }

    $(document).on('click', '[data-search-form] [data-search-button]', {}, function () {
        searchActon(this);
    });
    $(document).on('keydown', '[data-search-form] [data-search-action]', {}, function (e) {
        if (e.keyCode == 13)
            searchActon(this);
    });

    $('[data-search-form]').on('search', function (e, data) {
        var $sender = $(this);
        var $prefix = $sender.data('search-prefix');
        var _prefix = (IsNotNull($prefix) && $prefix != 'undefined') ? $prefix : GetSearchPrefixForRecordType($sender.data('search-form'));
        var pattern = /^\/\//;
        if (!pattern.test((_prefix != null && _prefix != '' && _prefix != 'undefined' ? _prefix : '') + data.query))
            window.location = (_prefix != null && _prefix != '' && _prefix != 'undefined' ? _prefix : '') + data.query;
    });
}

$(document).on("click", "[data-detail-link]", function (e) {
    try {
        if ($(e.target).closest('[data-non-click-content]').length > 0) return;
        if ($('[data-pcode]').data('pcode') == 'PSB' && location.pathname.startsWith('/property-search-map')) {
            $(".detailTarget").removeAttr('data-detail-link');
        }
        else if (!e.ctrlKey) {
            e.preventDefault();
            var $this = $(this);
            var _detailUrl = $this.closest('.property').find('[data-detail-url]').data('detail-url');
            if (_detailUrl != null && _detailUrl != '' && $('[data-pcode]').data('pcode') !== 'PSB')
                window.open(_detailUrl);
            else if (_detailUrl != null && _detailUrl != '' && $('[data-pcode]').data('pcode') == 'PSB') {
                window.open(_detailUrl, '_self');
            }
            //newpage();
        }
    } catch (e) { console.log(e); }
});


function isElementVisible(el) {
    var rect = el.getBoundingClientRect(),
        vWidth = window.innerWidth || document.documentElement.clientWidth,
        vHeight = window.innerHeight || document.documentElement.clientHeight,
        efp = function (x, y) { return document.elementFromPoint(x, y) };

    // Return false if it's not in the viewport
    if (rect.right < 0 || rect.bottom < 0
        || rect.left > vWidth || rect.top > vHeight)
        return false;

    // Return true if any of its four corners are visible
    return (
        el.contains(efp(rect.left, rect.top))
        || el.contains(efp(rect.right, rect.top))
        || el.contains(efp(rect.right, rect.bottom))
        || el.contains(efp(rect.left, rect.bottom))
    );
}

function OnSelectOneSearchItemToForm(item, controlID) {
    $('[id$="' + controlID + '"]').closest('[data-search-form]').data('item', item);
}

function OnSuccessOneSearchItem(controlID) {
    var item = $('[id$="' + controlID + '"]').closest('[data-search-form]').data('item');
    var searchType = typeof (item) != 'undefined' && item != null && typeof (item.rt) != 'undefined' ? item.rt : '';
    switch (searchType) {
        case "LOCATION":
            $('[id$="' + controlID + '"]').closest('[data-search-form]').find('[data-search-button]').trigger('click');
            break;
    }
}

function ClearFormval($form) {
    $($form).find('input,select,textarea').each(function () {
        if ($(this).is('input[type="checkbox"]')) {
            if ($(this).closest('.mdl-js-checkbox').length > 0)
                $(this).closest('.mdl-js-checkbox')[0].MaterialCheckbox.uncheck();
            else
                $(this).prop('checked', false);
        } else if ($(this).is('input[type="radio"]')) {
            if ($(this).closest('.mdl-js-radio').length > 0)
                $(this).closest('.mdl-js-radio')[0].MaterialRadio.uncheck();
            else
                $(this).prop('checked', false);
        }
        else if ($(this).is('input[type="text"]') || $(this).is('textarea')) {
            $(this).val('');
            if ($(this).closest('.mdl-js-textfield').length > 0)
                $(this).closest('.mdl-js-textfield')[0].MaterialTextfield.checkDirty();
        } else if ($(this).is('select')) {
            $(this).prop("selectedIndex", 0);
            if ($(this).closest('.mdl-js-selectfield').length > 0)
                $(this).closest('.mdl-js-selectfield')[0].MaterialSelectfield.mdlDowngrade_();
        }
        else if ($(this).is('input[type="file"]')) {
            $(this).val('');
        }
    });
    if (!(typeof (componentHandler) == 'undefined')) {
        componentHandler.upgradeDom();
    }
}




function EnableBrytecore() {
    var _bryteCoreStack = [];

    function _pushEvent(event) {
        _bryteCoreStack.push(event);
    }

    function _popEvent() {
        return _bryteCoreStack.pop();
    }

    function _bryteCore(event, params) {
        var _isDebug = window.location.host.indexOf('localhost') > -1;
        var _isStage = window.location.host.indexOf('stage') > -1;
        try {
            if (_isDebug || _isStage) {
                console.log('BRT');
                console.log("event : " + event);
                console.log("data : " + params);
            } else {
                if (typeof (brytescore) != 'undefined' && brytescore != null) {
                    console.log('BRTTRUE');
                    console.log("event : " + event);
                    console.log("data : " + params); brytescore(event, params);
                }
            }
        } catch (e) { console.log(e); }
    }

    function _getBRTTagType($node) {
        if ($node.is('[data-brt-track]')) return 2;
        else if ($node.is('[data-brt-track-event]')) return 1;
        return 0;
    }

    function _parseToParams($node) {
        var _nodeType = _getBRTTagType($node);
        var _brtParams = {};
        try {
            var _brt = $node.attr('data-brt-track');
            var _brtParts = _brt.split(',');
            //if (_brtParts.length > 0) _brtParams.events = _brtParts[0];
            for (var i = 1; i < _brtParts.length; i++) {
                try {
                    _brtParams[_brtParts[i]] = null;
                    var _nodeParamValue = $node.attr('data-' + _brtParts[i].toLowerCase());
                    console.log(_nodeParamValue);
                    if (_brtParts[i].toLowerCase() == "islead") { _brtParams[_brtParts[i]] = true; }
                    if (typeof (_nodeParamValue) != 'undefined' && _brtParts[i].toLowerCase() != "islead")
                        _brtParams[_brtParts[i]] = _nodeParamValue[0] == '{' && _nodeParamValue[_nodeParamValue.length - 1] == '}' ? $.parseJSON(_nodeParamValue.replace(/\'/gi, '"')) : _nodeParamValue;
                } catch (ex) { }
            }
        } catch (e) { }
        return _brtParams;
    }

    function _parseToEvents($node) {
        var _nodeType = _getBRTTagType($node);
        var _brtEvents;
        try {
            var _brt = $node.attr('data-brt-track');
            var _brtParts = _brt.split(',');
            if (_brtParts.length > 0) _brtEvents = _brtParts[0];
        } catch (e) { }
        return _brtEvents;
    }


    function _bryteCoreTrack($node) {
        _bryteCore(_parseToEvents($node), _parseToParams($node));
    }


    $(document).on('track', '[data-brt-track]', null, function (e) {
        _bryteCoreTrack($(this));
    });


    $(document).on('click', '[data-brt-click][data-brt-track]', null, function (e) {
        $(this).trigger('track');
    });

    $(document).on('brt-track', 'body', null, function (e, data) {
        _bryteCore(data);
    });
}
function getBRTSearchtags(urlQuery, trackContainer, ResultCount) {
    var _brtParams = '';
    var _events = trackContainer.data('brt-track');
    var _searchUrl = trackContainer.attr('data-searchurl');
    try {
        _brtParts = urlQuery.split('/');
        if (ResultCount != '' && ResultCount != '0') _brtParams += writeTag('resultsCount', ResultCount.replace(',', ''));
        for (var i = 0; i < _brtParts.length; i++) {
            var _nodeParamValue;
            var _singleQuerySplit = {};
            var _termValue;
            var _urlterm;
            try {
                _singleQuerySplit = _brtParts[i].split('-');
                console.log(_singleQuerySplit);
                if (_singleQuerySplit.length == 1) {
                    _urlterm = _singleQuerySplit[0];
                    if (_urlterm == 'fore') { _brtParams += writeTag('isForeclosureAcreage', true); }
                }
                if (_singleQuerySplit.length == 2) {
                    _urlterm = _singleQuerySplit[0];
                    _termValue = _singleQuerySplit[1];
                    var _nodeTag = $('[data-search-form="QUICKSEARCH"]').find('[UrlIdentifier="' + _urlterm + '"][data-brt-tag]').data('brt-tag');
                    if (typeof (_nodeTag) != 'undefined') {
                        _brtParams += writeTag(_nodeTag, _termValue);
                    }
                }
                if (_singleQuerySplit[0] == 'price' && _singleQuerySplit.length == 3) {
                    _urlterm = _singleQuerySplit[0];
                    var _nodeTag1 = $('[data-search-form="QUICKSEARCH"]').find('[Operation="min"][UrlIdentifier="' + _urlterm + '"][data-brt-tag]').data('brt-tag');
                    var _nodeTag2 = $('[data-search-form="QUICKSEARCH"]').find('[Operation="max"][UrlIdentifier="' + _urlterm + '"][data-brt-tag]').data('brt-tag');
                    if (typeof (_nodeTag1) != 'undefined' && typeof (_nodeTag2) != 'undefined') { _brtParams += writeTag(_nodeTag1, _singleQuerySplit[1]); _brtParams += writeTag(_nodeTag2, _singleQuerySplit[2]); }
                }

                ////
                //if (_singleQuerySplit[0] == 'l' || _singleQuerySplit[0] == 'county') {
                //    _urlterm = _singleQuerySplit[0];
                //    _termValue = _singleQuerySplit[1].replace(/^;|;$/g, '');
                //    var _defaultEvent;
                //    var _stringArray = '[' + _termValue.split(';') + ']';
                //    _defaultEvent = _urlterm == 'l' ? 'cities' : _urlterm == 'county' ? 'counties' : '';
                //    _brtParams += writeTag(_defaultEvent, _stringArray);
                //}
                ////

                if ((_singleQuerySplit[0] == 'lat' || _singleQuerySplit[0] == 'lon') && _singleQuerySplit.length == 3) {
                    if (_singleQuerySplit[0] == 'lat') {
                        var _latPoint1 = _singleQuerySplit[1];
                        var _latPoint2 = _singleQuerySplit[2];
                    }
                    if (_singleQuerySplit[0] == 'lon') {
                        var _lonPoint1 = _singleQuerySplit[1];
                        var _lonPoint2 = _singleQuerySplit[2];
                        var _boundary = '[{"latitude":' + _latPoint1 + ' , "longitude":' + _lonPoint1.replace('_', '-') + ' },{"latitude":' + _latPoint2 + ' , "longitude":' + _lonPoint2.replace('_', '-') + ' }]';
                        _brtParams += writeTag('boundaries', _boundary);
                    }
                }
                if (_singleQuerySplit[0] == 'type') {
                    _termValue = _singleQuerySplit[1];
                    if (_termValue.indexOf('Single Family') > -1) { _brtParams += writeTag('isSingleFamily', true); }
                    if (_termValue.indexOf('Condo') > -1) { _brtParams += writeTag('isCondo', true); }
                    if (_termValue.indexOf('Land') > -1) { _brtParams += writeTag('isLot', true); }
                    if (_termValue.indexOf('Multi') > -1) { _brtParams += writeTag('isMultiFamily', true); }
                }
            }
            catch (ex) { }
        }
        if (trackContainer.data('search-form-type') == 'PropertyMapSearch') { _brtParams += writeTag('isMapSearch', true); }
        _brtParams += writeTag('searchURL', '"' + _searchUrl + '"', true);
        var _searchObj = '{' + _brtParams + '}';
        trackContainer.attr('data-search', _searchObj);

        _events = _events.replace('searchURL', 'search');
    }
    catch (e) { }
    return _events;
}

function writeTag(name, value, isLastNode) {
    var _trailingComma = '';
    _trailingComma = isLastNode ? _trailingComma : ',';
    return '"' + name + '" : ' + value + _trailingComma;
}

function getBRTContact(sender) {
    var _formTag = sender.attr('data-form');
    var _contactEmail = sender.find('[node="Email"]').val();
    var _contactFName = sender.find('[node="FirstName"]').val();
    var _contactLName = sender.find('[node="LastName"]').val();
    var _contactPhone = sender.find('[node="MobilePhone"]').val();
    var _contactRemarks = sender.find('[node="Remarks"]').val();
    var _formTagJSON = $.parseJSON('{' + _formTag + '}');

    var _formObj = {};
    _formObj.fromEmail = _contactEmail;
    _formObj.fromName = _contactFName + ' ' + _contactLName;
    _formObj.fromTelephone = {};
    _formObj.fromTelephone.mobile = _contactPhone;
    _formObj.message = _contactRemarks;
    for (var key in _formTagJSON)
        _formObj[key] = _formTagJSON[key];
    //_formObj. = '{"fromEmail":"' + _contactEmail + '","fromName":"' + _contactFName + ' ' + _contactLName + '","fromTelephone":{"mobile": "' + _contactPhone + '"},"message":"' + _contactRemarks + '",' + _formTag + '}';
    return _formObj;
}

function getBRTEvents(sender) {
    var _brtEvents;
    try {
        var _brt = sender.attr('data-brt-track');
        var _brtParts = _brt.split(',');
        if (_brtParts.length > 0) _brtEvents = _brtParts[0];
    } catch (e) { }
    return _brtEvents;
}

function EnableDynamicContentLoad() {
    $(document).on('init', '[data-dynamic-content]', {}, function () {
        var $sender = $(this);
        var $loader = $sender.find('[data-loader]');
        var $loadContext = $sender.find('[data-context]');
        if ($loadContext.length == 0)
            $loadContext = $sender;
        $loader.removeClass('mdl-cell--hide');
        var _url = $sender.data('dynamic-content');
        $.ajax({
            type: "GET",
            url: _url,
            success: function (data) {
                $loadContext.html(data);
                $loader.addClass('mdl-cell--hide');
            },
            failure: function (data) {
                $loader.addClass('mdl-cell--hide');
            },
            error: function (data) {
                $loader.addClass('mdl-cell--hide');
            }
        });

    });

    $('[data-dynamic-content]:not([data-dynamic-content-trigger]:not([data-init]))').trigger('init');
    $('[data-dynamic-content][data-dynamic-content-trigger]:not([data-init])').each(function () {
        var $this = $(this);
        var $trigger = $('#' + $this.data('dynamic-content-trigger'));
        if ($trigger.length > 0) {
            $trigger.on('change', function () { if ($(this).is(':checked')) { $this.trigger('init'); $trigger.off('change'); } })
            $trigger.find(':checked').trigger('change');
        }
    });
}

function EnableSearchBar() {
    function _getWidth() { return $(window).width(); }
    function _isValidExtendedSearchView() { return _getWidth() < 1025; }
    function _performSearchBarTrigger() { if (_isValidExtendedSearchView()) _openFilterWindow(); }
    function _openFilterWindow() { $('body').addClass('search-bar-opened'); }
    function _closeFilterWindow() { $('body').removeClass('search-bar-opened'); }
    $('.SearchBar [data-search="oneSearch"]').on('focusin', _performSearchBarTrigger);
    $('.SearchBar [data-search-label="oneSearch"]').on('click', _performSearchBarTrigger);
    $('.SearchBar [data-search-close]').on('click', _closeFilterWindow);
    $(window).on('resize', function () { if (!_isValidExtendedSearchView()) _closeFilterWindow });
}

function getBRTSearchtags(urlQuery, trackContainer, ResultCount) {
    var _brtParams = '';
    var _events = trackContainer.data('brt-track');
    var _searchUrl = trackContainer.attr('data-searchurl');
    try {
        _brtParts = urlQuery.split('/');
        if (ResultCount != '' && ResultCount != '0') _brtParams += writeTag('resultsCount', ResultCount.replace(',', ''));
        for (var i = 0; i < _brtParts.length; i++) {
            var _nodeParamValue;
            var _singleQuerySplit = {};
            var _termValue;
            var _urlterm;
            try {
                _singleQuerySplit = _brtParts[i].split('-');
                console.log(_singleQuerySplit);
                if (_singleQuerySplit.length == 1) {
                    _urlterm = _singleQuerySplit[0];
                    if (_urlterm == 'fore') { _brtParams += writeTag('isForeclosureAcreage', true); }
                }
                if (_singleQuerySplit.length == 2) {
                    _urlterm = _singleQuerySplit[0];
                    _termValue = _singleQuerySplit[1];
                    var _nodeTag = $('[data-search-form="QUICKSEARCH"]').find('[UrlIdentifier="' + _urlterm + '"][data-brt-tag]').data('brt-tag');
                    if (typeof (_nodeTag) != 'undefined') {
                        _brtParams += writeTag(_nodeTag, _termValue);
                    }
                }
                if (_singleQuerySplit[0] == 'price' && _singleQuerySplit.length == 3) {
                    _urlterm = _singleQuerySplit[0];
                    var _nodeTag1 = $('[data-search-form="QUICKSEARCH"]').find('[Operation="min"][UrlIdentifier="' + _urlterm + '"][data-brt-tag]').data('brt-tag');
                    var _nodeTag2 = $('[data-search-form="QUICKSEARCH"]').find('[Operation="max"][UrlIdentifier="' + _urlterm + '"][data-brt-tag]').data('brt-tag');
                    if (typeof (_nodeTag1) != 'undefined' && typeof (_nodeTag2) != 'undefined') { _brtParams += writeTag(_nodeTag1, _singleQuerySplit[1]); _brtParams += writeTag(_nodeTag2, _singleQuerySplit[2]); }
                }

                ////
                //if (_singleQuerySplit[0] == 'l' || _singleQuerySplit[0] == 'county') {
                //    _urlterm = _singleQuerySplit[0];
                //    _termValue = _singleQuerySplit[1].replace(/^;|;$/g, '');
                //    var _defaultEvent;
                //    var _stringArray = '[' + _termValue.split(';') + ']';
                //    _defaultEvent = _urlterm == 'l' ? 'cities' : _urlterm == 'county' ? 'counties' : '';
                //    _brtParams += writeTag(_defaultEvent, _stringArray);
                //}
                ////

                if ((_singleQuerySplit[0] == 'lat' || _singleQuerySplit[0] == 'lon') && _singleQuerySplit.length == 3) {
                    if (_singleQuerySplit[0] == 'lat') {
                        var _latPoint1 = _singleQuerySplit[1];
                        var _latPoint2 = _singleQuerySplit[2];
                    }
                    if (_singleQuerySplit[0] == 'lon') {
                        var _lonPoint1 = _singleQuerySplit[1];
                        var _lonPoint2 = _singleQuerySplit[2];
                        var _boundary = '[{"latitude":' + _latPoint1 + ' , "longitude":' + _lonPoint1.replace('_', '-') + ' },{"latitude":' + _latPoint2 + ' , "longitude":' + _lonPoint2.replace('_', '-') + ' }]';
                        _brtParams += writeTag('boundaries', _boundary);
                    }
                }
                if (_singleQuerySplit[0] == 'type') {
                    _termValue = _singleQuerySplit[1];
                    if (_termValue.indexOf('Single Family') > -1) { _brtParams += writeTag('isSingleFamily', true); }
                    if (_termValue.indexOf('Condo') > -1) { _brtParams += writeTag('isCondo', true); }
                    if (_termValue.indexOf('Land') > -1) { _brtParams += writeTag('isLot', true); }
                    if (_termValue.indexOf('Multi') > -1) { _brtParams += writeTag('isMultiFamily', true); }
                }
            }
            catch (ex) { }
        }
        if (trackContainer.data('search-form-type') == 'PropertyMapSearch') { _brtParams += writeTag('isMapSearch', true); }
        _brtParams += writeTag('searchURL', '"' + _searchUrl + '"', true);
        var _searchObj = '{' + _brtParams + '}';
        trackContainer.attr('data-search', _searchObj);

        _events = _events.replace('searchURL', 'search');
    }
    catch (e) { }
    return _events;
}


// Fix: The validation MDL text box not to turn red on load


function UpdateUserAreaHtml(html) { $('#USERAREA').html(html); }

function attachLeadFormConsentStatement() {
    $("[data-request-submit],[data-submit-tatext]").each(function () {
        var _consent = 'I agree to be contacted by <i class="data-company-name" data-spacer=""></i> via email, phone, and text to receive real estate services and information. You can reply STOP to unsubscribe or HELP for assistance with text messages. You can also click the unsubscribe link in emails. Message and data rates may apply. Message frequency may vary. <a aria-label="policy" role="link" target="_blank" href="/privacy-policy"><u>Privacy Policy</u></a>'
        if ($(this).attr('no-consentmessage') === undefined) { // if no consent message is needed in form, use 'no-consentmessage' attribute
            if ($(this).attr("no-checkbox") !== undefined) { // hide checkbox option , use 'no-checkbox' attribute
                if ($(this).attr("consent-attached") != "true") {
                    if ($(this).parent().parent().html().indexOf('Cancel') > 0) {
                        $(this).parent().parent().before('<div class="mdl-cell mdl-cell--12-col mdl-cell--8-col-tablet acknowledgement-policy">' + _consent + '</div>');
                    }
                    else {
                        $(this).parent().before('<div class="mdl-cell mdl-cell--12-col mdl-cell--8-col-tablet acknowledgement-policy">' + _consent + '</div>');
                    }
                    $(this).attr('consent-attached', 'true');
                }
                return;
            }
            if ($(this).attr("consent-attached") != "true") {
                if ($(this).parent().parent().html().indexOf('Cancel') > 0) {
                    $(this).parent().parent().before('<div class="mdl-cell mdl-cell--12-col mdl-cell--8-col-tablet acknowledgement-policy"><label class="mdl-checkbox mdl-js-checkbox " ><input type="checkbox" node="Consent" class="mdl-checkbox__input"><span class="mdl-checkbox__label">' + _consent + ' </label></div>');
                }
                else {
                    $(this).parent().before('<div class="mdl-cell mdl-cell--12-col mdl-cell--8-col-tablet acknowledgement-policy"><label class="mdl-checkbox mdl-js-checkbox " ><input type="checkbox" node="Consent" class="mdl-checkbox__input"> <span class="mdl-checkbox__label">' + _consent + '</label></div>');
                }
                $(this).attr('consent-attached', 'true');
            }
        }


    });
}

function EnableLeadForm() {
    attachLeadFormConsentStatement();
    $(document).off('click', 'a.emailform,a.email-agent');
    $(document).on('click', 'a.emailform,a.email-agent', null, function () {
        try {
            var _relAgentKey = $(this).attr('rel');
            if (_relAgentKey == null || typeof (_relAgentKey) == 'undefined' || _relAgentKey.trim() == '') return;
            var _agentKey = parseInt(_relAgentKey);
            $("#ContactMeModal").AgoraDialogModal({ ServiceUrl: '/PopUps/LeadForm/ContactUs.aspx?agentkey=' + _agentKey, EnableAjaxHtmlLoad: true });
        } catch (e) { }
    });

    $(document).off('change', '[Node="LeadFormOwnerOffice"]');
    $(document).on('change', '[Node="LeadFormOwnerOffice"]', null, function () {
        try {
            $("#hdnLeadofficename").attr("value", this.options[this.selectedIndex].text);

        } catch (e) { }

    });

    $(document).off('engage', '[data-request-submit]');
    $(document).on('engage', '[data-request-submit]', null, function () {
        try {
            var $sender = $(this);
            $sender.addClass('loading');
            ShowLoading();
        } catch (e) { }
    });
    $(document).off('disengage', '[data-request-submit]');
    $(document).on('disengage', '[data-request-submit]', null, function () {
        try {
            var $sender = $(this);
            $sender.removeClass('loading');
            ShowLoading();
        } catch (e) { }
    });

    $(document).off('end', '[data-request-submit],[data-website-sign-up-button]');
    $(document).on('end', '[data-request-submit],[data-website-sign-up-button]', null, function () {
        try {
            var $sender = $(this);
            var $form = $sender.parents('[data-request]');
            var $dataReveal = null;
            var $trackForm = null;
            var $requestType = $sender.parents('[data-request]').data('request');
            if ($('[data-trackid]').length > 0) {
                $trackForm = $('[data-trackid]').data('trackid');
                $requestType = $trackForm;
            }

            var $mlsNumber = $sender.parents('[data-request]').find('[node="PropertyMlsnumber"]').val();
            var _succesUrl = $sender.parents('[data-request]').data('request-success') + '?type=' + $sender.parents('[data-request]').data('request') + '&stype=' + $sender.parents('[data-request]').data('request-subtype') + '&IsPageReload=' + $sender.parents('[data-request]').data('reloadpage');

            var _trackVal = ($requestType == "RequestShowing" || $requestType == "RequestInfo") ? $('body').find('[data-listing-gtm-track]').data('formsubmitted') : $('body').find('[data-form-gtm-track]').data('formsubmitted');
            switch ($requestType) {
                case "RequestShowing":
                    _trackVal = _trackVal.replace("'requestShowing':'false'", "'requestShowing':'true'");
                    _trackVal = _trackVal.replace("'listingID':'MLS'", "'listingID':'" + $mlsNumber + "'");
                    _trackVal = _trackVal.replace("'FormID':'contactForm'", "'form_id':'" + $requestType + "'");
                    _trackVal = _trackVal.replace("'FormId':'requestDetails'", "'form_id':'" + $requestType + "'");
                    $('body').find('[data-listing-gtm-track]').attr('data-formsubmitted', _trackVal);
                    $('body').find('[data-listing-gtm-track]').trigger('track');
                    break;
                case "RequestInfo":
                    _trackVal = _trackVal.replace("'listingID':'MLS'", "'listingID':'" + $mlsNumber + "'");
                    _trackVal = _trackVal.replace("'FormID':'contactForm'", "'form_id':'" + $requestType + "'");
                    _trackVal = _trackVal.replace("'FormId':'requestDetails'", "'form_id':'" + $requestType + "'");
                    $('body').find('[data-listing-gtm-track]').attr('data-formsubmitted', _trackVal);
                    $('body').find('[data-listing-gtm-track]').trigger('track');
                    break;
                default:
                    _trackVal = _trackVal.replace("'FormID':'contactForm'", "'form_id':'" + $requestType + "'");
                    _trackVal = _trackVal.replace("'FormId':'requestDetails'", "'form_id':'" + $requestType + "'");
                    $('body').find('[data-form-gtm-track]').attr('data-formsubmitted', _trackVal);
                    $('body').find('[data-form-gtm-track]').trigger('track');
                    break;
            }

            //$('[data-success-gaw-track]').trigger('track');

            if (!$sender.parents('[data-request]').is('[data-inline-form]')) {
                $dataReveal = $sender.parents('[data-reveal]');
            } else {
                $dataReveal = $($sender.parents('[data-request]').data('inline-form'));
                $sender.parents('[data-request]').find('input').val('');
            }
        }
        catch (e) { }
        finally {
            if (typeof (_succesUrl) != 'undefined' && !_succesUrl.startsWith('undefined')) {
                setTimeout(function () {
                    $("#IwbPopUpArea").AgoraDialogModal({ ServiceUrl: _succesUrl, EnableAjaxHtmlLoad: true });
                }, 700);
            }
        }
    });

    $(document).off('error', '[data-request-submit]');
    $(document).on('error', '[data-request-submit]', null, function (event, response) {
        console.log(response);
        try {
            var $dataReveal = null;
            var $sender = $(this);
            var responseNumber = 'undefined';
            if (!$sender.parents('[data-request]').is('[data-inline-form]')) {
                $dataReveal = $sender.parents('[data-reveal]');
            } else {
                $dataReveal = $($sender.parents('[data-request]').data('inline-form'));
                $sender.parents('[data-request]').find('input').val('');
            }
            setTimeout(function () {
                if (responseNumber != undefined && response.response.response.Number == '403') {
                    $("#IwbPopUpArea").AgoraDialogModal({ ServiceUrl: '/PopUps/LeadForm/Error.aspx?response=403', EnableAjaxHtmlLoad: true });
                    clearTimeout()
                }
                else {
                    $("#IwbPopUpArea").AgoraDialogModal({ ServiceUrl: '/PopUps/LeadForm/Error.aspx', EnableAjaxHtmlLoad: true });

                }
            }, 700);
        } catch (e) { }
    });

    function Contactvalidate() {
        var val;
        $('#ContactUs_Form :input').each(function () {
            if (($(this).prop('required') == true && $(this).val().length <= 0) || ($(this).attr('node') == 'Email' && !isValidEmail($(this).val()))) {
                ShowAlert($(this).attr('formmessage'), 3000, 'alert_box', null);
                $(this).parent("div").addClass("is-invalid");
                val = false;
                return false;
            }
            else {
                $(this).parent("div").removeClass("is-invalid");
                val = true;
                return true;
            }

        });
        return val;
    }

    $(document).off('click', '[data-request-submit]');
    $(document).on('click', '[data-request-submit]', null, function () {
        var $sender = $(this);
        try {
            $sender.trigger('engage');
            var $senderForm = $sender.parents('[data-request]');
            var _phone = $senderForm.find('[node="MobilePhone"]').val();
            _phone = IsNotNull(_phone) ? _phone.replace(/[^0-9]/gi, '') : _phone;
            var _email = $senderForm.find('[node="Email"]').val();
            var _consent = $senderForm.find('[node="Consent"]');

            if (IsNotNull(_email) && !isValideEmail(_email)) { ShowAlert('Please ensure you enter a valid email address.', 3000, 'alert_box', null); $sender.trigger('disengage'); return; }
            if (IsNotNull($senderForm.find('[node="MobilePhone"]').val()) && _phone.length < 10 && !$senderForm.find('[node="MobilePhone"]').hasClass('disablephoneformat')) { ShowAlert(!isNullOrEmpty($senderForm.find('[node="MobilePhone"]').attr('formmessage')) ? $senderForm.find('[node="MobilePhone"]').attr('formmessage') : 'Please enter a 10-digit phone number. For example: (123) 123-1234', 3000, 'alert_box', null); $sender.trigger('disengage'); return; }
            else if (IsNotNull($senderForm.find('[node="MobilePhone"]').val()) && _phone.length < 4 && $senderForm.find('[node="MobilePhone"]').hasClass('disablephoneformat')) { ShowAlert(!isNullOrEmpty($senderForm.find('[node="MobilePhone"]').attr('formmessage')) ? $senderForm.find('[node="MobilePhone"]').attr('formmessage') : 'Please enter a 10-digit phone number. For example: (123) 123-1234', 3000, 'alert_box', null); $sender.trigger('disengage'); return; }
            if (_consent.length > 0 && !_consent.prop('checked')) {
                ShowAlert('Please check the box to give your consent to be contacted.', 3000, 'alert_box', null);
                $sender.trigger('disengage');
                return;
            }
            console.log('$senderForm', $senderForm);
            var _formXml = GetFormXml($senderForm);
            if (_formXml == null) {
                $sender.trigger('disengage');
                return;
            }
            var _isValid = null;
            try {
                _isValid = $senderForm.triggerHandler('validate', _formXml);
            } catch (e) { }
            if (typeof (_isValid) != 'undefined' && _isValid != null && !_isValid) {
                $sender.trigger('disengage');
                return;
            }
            setRecaptchaToken($(this))
            var _type = $senderForm.data('request');
            SubmitRequest($sender, _type, _formXml, function (sender, response) {
                $sender.trigger('disengage');
                $sender.trigger('end');
            }, function (sender, response) {
                $sender.trigger('disengage');
                $sender.trigger('error', { response: response });
            }, function (sender, response) {
                $sender.trigger('disengage');
            });
        } catch (e) { console.log('Error : ' + e); $sender.trigger('disengage'); }
    });
}
function setRecaptchaToken(sender) {

    $.ajax({
        url: '/services/RegenerateToken.aspx/token',
        type: "POST",
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        success: function (result) {

            console.log("scucess", result.d);
            if (sender.parents('[data-request]').find('[node = "CaptchaToken"]').length) {
                sender.parents('[data-request]').find('[node = "CaptchaToken"]').attr("value", result.d);
            }
        },
        error: function (err) {
        }
    });

}
function EnableAVMControl() {
    $("#btnwhatmyhomeworth").click(function () {
        var $sender = $(this);
        console.log('here');
        if ($("#txt_home-evaluation").val() != '') {
            if ($sender.is('[data-enable-alert]')) ShowAlert($sender.data('enable-alert'), 3000, 'alert_box', null);
            var textfieldmask = /((\s|\,)?(\s|\,|\-)?)/gi;
            if (textfieldmask.test($("#txt_home-evaluation").val())) {
                var _url = "/avm?address=" + ($("#txt_home-evaluation").val());

                window.location.href = _url;
                $('#txt_home-evaluation').val('');
            } else { setTimeout(function () { }, 200); alert("Please enter a valid Address with both City and State (ex: Mobile, STATE (CITY))"); }

        } else {
            setTimeout(function () { }, 200);
            alert("Please enter a valid Address");
        }
    });

    $('#txt_home-evaluation').keypress(function (e) {
        var key = e.which;

        if (key == 13) {
            $("#btnwhatmyhomeworth").on('click');
            return false;
        }
    });
}

$(document).on('click', '[data-adfenix-track-phone]', function () {

    if (window.adfenix) {
        console.log("contactrequestclick");
        window.adfenix.track('contactrequestclick');
    }
});

function getAvmFunction() {
    $('[data-search-avm-button]').click(function () {
        var address = $("#txt_home-evaluation").val();
        if ($("#txt_home-evaluation").val() != '') {

            var _originUrl = document.referrer;
            if (_originUrl.match("/buyselljourney")) {
                if (window.adfenix) {
                    window.adfenix.track('contactrequestclick');
                }
            }
            var textfieldmask = /((\s|\,)?(\s|\,|\-)?)/gi;
            if (textfieldmask.test(address)) {
                var _url = "/avm?address=" + address;

                window.open(_url);
                $('#txt_home-evaluation').val('');
            } else { alert("Please enter a valid Address with both City and State (ex: Mobile, CA (California))"); }

        } else {
            alert("Please enter a valid Address");
        }
    });



    $('#txt_home-evaluation').keypress(function (e) {
        var key = e.which;

        if (key == 13) {
            $("[data-search-avm-button]").on('click');
            return false;
        }
    });
}

function openContacusForm() {
    if (window.location.hash == "#contact") {
        $("#IBPmodalcontainer").AgoraDialogModal({ ServiceUrl: '/PopUps/LeadForm/ContactUs.aspx?IsCustomerCare=true', EnableAjaxHtmlLoad: true });
    }
}
function ContactCustomerCare() {
    $("#IBPmodalcontainer").AgoraDialogModal({ ServiceUrl: '/PopUps/LeadForm/ContactUs.aspx?IsCustomerCare=true', EnableAjaxHtmlLoad: true });
}

function EnableDynamicQueryList() {
    $(document).on('init', '[data-query-list]', {}, function () {
        new DynamicQueryList(this);

    });

    $('[data-query-list-template]').each(function () {
        var $item = $(this);
        var templateType = $item.data('query-list-template');
        $item.html('');
        $item.load('/services/agoraTemplateService.aspx?type=' + templateType, function () {
            if (!(typeof (componentHandler) == 'undefined')) {
                componentHandler.upgradeDom();
            }
            $item.trigger('init');
        });
    });

    $('[data-query-list]:not([data-query-list-trigger]:not([data-init]))').trigger('init');
    $('[data-query-list][data-query-list-trigger]:not([data-init])').each(function () {
        var $this = $(this);
        var $trigger = $('#' + $this.data('query-list-trigger'));
        if ($trigger.length > 0) {
            $trigger.on('change', function () { if ($(this).is(':checked')) { $this.trigger('init'); $trigger.off('change'); } })
            $trigger.find(':checked').trigger('change');
        }
    });

    function DynamicQueryList(sender) {
        var _self = this;
        var tab_load;
        _self._serviceUrl = '/services/agoraGetFeaturedProperties.ashx';
        _self._disableOwlCarousel = false;
        _self._enableDemandScroll = false;
        _self._enableShowmoreButton = false;
        _self.$sender = $(sender);
        _self.$id = $(sender).attr("id");
        _self.$Itemcontainer = $('[data-item-container=' + _self.$sender.data('query-list-trigger') + ']');
        _self.$buttonScroll = $('a[data-page-scroll=' + _self.$id + ']');
        _self.$template = _self.$sender.find('[data-item-template]');
        _self.$context = _self.$sender.find('[data-items-context]');
        _self.$noItemContext = _self.$sender.find('[data-no-items-context]');
        _self.$noItemContextLabel = $("label[for='" + _self.$sender.data('query-list-trigger') + "']");
        _self.$contextItemExists = _self.$sender.find('[data-if-items-context]');
        _self.count = $('input[data-tab-loaded]').length;
        _self.$next = _self.$sender.find('[data-items-load-next]');
        _self.$loader = _self.$sender.find('[data-loader]');
        _self.$showmorebutton = _self.$sender.find('[data-showmore-button="' + _self.$sender.data('query-list-trigger') + '"]');

        _self._itemSliderSetting = _self.$sender.data('owl-slider-setting');

        if (typeof _self._itemSliderSetting !== 'undefined') {
            
            if (_self._itemSliderSetting.slice && _self._itemSliderSetting.slice(-1) === '1') {
                 _self._itemSliderSetting = '1,1,1';
            }
        }

        _self._itemsCount = _self.$sender.data('page-size');
        _self._extraParams = _self.$sender.data('extra-params');

        _self._stage = { 0: { items: 1, nav: true }, 640: { items: 2, nav: true }, 1024: { items: 3, nav: true, loop: false }, 1440: { items: 4, nav: true, loop: false } };
        if (typeof (_self._itemSliderSetting) != 'undefined') {
            
            var _items = _self._itemSliderSetting.split(',');
            var _i = 0;
            for (var _key in _self._stage)
                _self._stage[_key].items = _items[_i++];
        }
        _self._rt = _self.$sender.data('rt');
        _self._ownerRT = _self.$sender.data('owner-rt');
        _self._urlQuery = _self.$sender.data('urlquery');

        if (typeof (_self._itemsCount) == 'undefined') _self._itemsCount = 12;
        if (typeof (_self._urlQuery) == 'undefined') _self._urlQuery = '';
        if (typeof (_self._extraParams) == 'undefined') _self._extraParams = '';

        _self._ownerKey = _self.$sender.data('owner-key');
        if (IsNotNull(_self.$sender.data('service-url'))) _self._serviceUrl = _self.$sender.data('service-url');
        if (_self.$sender.data('enable-demandscroll') == '1') { _self._disableOwlCarousel = true; _self._enableDemandScroll = true; }
        if (_self.$sender.data('enable-showmore-button') == '1') { _self._disableOwlCarousel = true; _self._enableShowmoreButton = true; }

        if (_self.$sender.data('view-mode') == "gallery") {
            _self._disableOwlCarousel = true;
        }

        var _itemShow = _self.$sender.data('slider-view');

        _self._isInit = true;
        if (_self.$loader.length > 0) _self.$loader.removeClass('mdl-cell--hide')
        _self.$context.on('next', function () {
            if (!_self.$context.data('is-busy')) {
                if (_self.$context.data('page') < _self.$context.data('page-count')) {
                    _self.$context.data('is-busy', true);
                    _self.$context.data('page', _self.$context.data('page') + 1);
                    _self.$next.trigger('click');
                }
            }
        });

        function isVisible() {
            var _contentPosition = 0; var _contentHeight = 0;
            var _screenHeight = $(window).height();
            var _viewMin = $(window).scrollTop();
            var _viewMax = _viewMin + _screenHeight;
            _contentPosition = _self.$context.offset();
            _contentHeight = _self.$context.outerHeight() + 1;
            var _contentMin = _contentPosition.top;
            var _contentMax = _contentMin + _contentHeight;
            return (_viewMax >= _contentMin && _viewMin >= _contentMax);
        }
        function dynamicScroll() {
            console.log("_self", _self);
            console.log("_self.$context", _self.$context);

            if (!_self.$context.data('is-busy')) {
                if (isVisible) {
                    if (_self.$context.data('page') < _self.$context.data('page-count')) {
                        _self.$context.data('is-busy', true);
                        _self.$context.data('page', _self.$context.data('page') + 1);
                        _self.$next.trigger('click');
                    }
                }
            }
        }
        function getFirstElementChecked() {
            if (_self.count > 0 && tab_load == undefined) {
                getFirstElementChecked1();
                tab_load = 1;
            }
            else {
                if (_self.$noItemContextLabel.length > 0) {
                    $('input[type="radio"].query-list:not(.query-list-loaded)').removeAttr('checked');
                    var _checkedCount = $('input[type="radio"]:not(.query-list):checked').filter(':first').length;
                    if (_checkedCount == 0) $('input[id="' + $('label.query-list-loaded').filter(':first').attr('for') + '"]')[0].checked = true;
                }
            }
        }
        //Changed For tab issue
        function getFirstElementChecked1() {
            $('input[id="' + $('label.mdl-cell--hide').attr('for') + '"]').attr('data-tab-value', '0');
            if (_self.$noItemContextLabel.length > 0) {
                setTimeout(function () {
                    $('input[id="' + $('label.query-list-loaded').filter(':first').attr('for') + '"]').attr('data-tab-loaded', 'true').attr('data-tab-value', '1');
                    var c = $('input[data-tab-value]').length;
                    if (_self.count != c) return;
                    setTimeout(function () {
                        $('input[data-tab-value="1"]')[0].checked = true;
                    }, 500);
                }, 300);
            }
        }
        _self.$context.AjaxScroller({
            NextBtn: _self.$next.attr('id'),
            PreviousBtn: null,
            TemplateId: _self.$template.attr('id'),
            ServiceUrl: _self._serviceUrl,
            Params: 'ownerRT=' + _self._ownerRT + '&ownerPK=' + _self._ownerKey + '&RT=' + _self._rt + '&urlQuery=' + _self._urlQuery + '&Q=' + _self._urlQuery + _self._extraParams,
            FullAjax: true,
            Transition: 'FadeIn',
            EnableCache: false,
            PageNumber: 1,
            DemandScroll: _self._enableDemandScroll,
            DemandScrollContext: _self.$context,
            ShowNextPage: _self._enableShowmoreButton,
            ItemsPerShow: _self._itemsCount,
            success: function (data) {
                console.log(data.ResultCount);
            },
            OnlyShowFirstPage: true,
            AfterHtmlResultInvoke: function (options, data, dataHtml) {
                _self.$loader.addClass('mdl-cell--hide');
                $('input[id="' + _self.$sender.data('query-list-trigger') + '"]').addClass('query-list').attr('data-tab-value', '1');
                console.log("data.ResultCount", data.ResultCount);
                if (_self.$sender.data('query-list-trigger') == 'radAgentBio3' && data.ResultCount > 0)
                    $('.featured-hld-mylistings').removeClass('mdl-cell--hide');
                    $('.featured-ivr-mylistings').removeClass('mdl-cell--hide');
                if (_self.$sender.data('query-list-trigger') == 'radAgentBio4' && data.ResultCount > 0)
                    $('.featured-ivr-mysoldlistings').removeClass('mdl-cell--hide');
                var _remains = (data.ResultCount - (options.ItemsPerShow * data.PageNumber));
                if (_remains > 0) {
                    if (_self._rt === 'AGENT') { _self.$showmorebutton.html('<b>' + _remains + '</b> More Agents'); }
                    else { _self.$showmorebutton.html('<b>' + _remains + '</b> More Properties'); }
                }
                else { _self.$showmorebutton.addClass('mdl-cell--hide'); }
                if (data.ResultCount < 1) {
                    //if (!$sender.hasAttribute("data-is-visible-noitemcontext")) {
                    _self.$noItemContext.removeClass('mdl-cell--hide');
                    _self.$noItemContext.addClass('Context-no-data-avaliable');
                    // if (_self.$noItemContext.length > 0) { _self.$noItemContext.addClass('mdl-cell--hide'); }
                    //}
                } else {
                    _self.$contextItemExists.removeClass('mdl-cell--hide');
                    _self.$sender.removeClass('mdl-cell--hide');

                    _self.$noItemContextLabel.addClass('query-list-loaded');

                    $('input[id="' + _self.$sender.data('query-list-trigger') + '"]').addClass('query-list-loaded');

                    if (_self.$noItemContextLabel.length > 0) { _self.$noItemContextLabel.removeClass('mdl-cell--hide'); }

                    if (_self.$Itemcontainer.length > 0) { _self.$Itemcontainer.removeClass('mdl-cell--hide'); }

                    if (_self.$buttonScroll.length > 0) { _self.$buttonScroll.removeClass('mdl-cell--hide'); }

                }


                if (data.PageNumber > 1) {
                    var t = $('<div>').html(dataHtml);
                    $(t).find('.item').each(function () {
                        var s = $('<div>').append($(this));
                        if (!_self._disableOwlCarousel) _self.$context.trigger('add.owl.carousel', $(s).html());
                        if (options.DemandScroll) _self.$context.append((s).html());
                        if (options.ShowNextPage) _self.$context.append((s).html());
                    });
                    $(t).find('.property').each(function () {
                        var s = $('<div>').append($(this));
                        _self.$context.trigger('add.owl.carousel', $(s).html())
                    });
                    _self.$context.trigger('refresh.owl.carousel');
                }
                setTimeout(function () {
                    _self.$sender.find('.property:not(.init)').each(function () {
                        GetPropertyImageGallery($(this));
                        $(document).trigger('enable-converter');
                    });
                }, 1000);
            },
            AfterResultInvoke: function (options, data) {


                if (data.PageNumber >= 1 && options.ShowNextPage) {
                    _self.$context.data('position', 0);
                    _self.$context.data('page', data.PageNumber);
                    _self.$context.data('page-count', data.PageCount);
                    _self.$context.data('page-size', data.PageSize);
                    _self.$context.data('is-busy', false);
                    getFirstElementChecked();
                    $(_self.$showmorebutton).click(function () {
                        _self.$showmorebutton.addClass('loading');
                        dynamicScroll();
                        _self.$sender.find('.property:not(.init)').each(function () {
                            GetPropertyImageGallery($(this));
                        });
                    });
                    _self.$showmorebutton.removeClass('loading');
                }
                else {
                    _self.$context.data('is-busy', false);
                }

                if (data.PageNumber <= 1 && options.DemandScroll) {
                    setTimeout(function () {
                        _self.$context.data('position', 0);
                        _self.$context.data('page', data.PageNumber);
                        _self.$context.data('page-count', data.PageCount);
                        _self.$context.data('page-size', data.PageSize);
                        _self.$context.data('is-busy', false);
                        $(document).trigger('enable-converter');

                        getFirstElementChecked();

                        $(window).scroll(function () {
                            dynamicScroll();
                            _self.$sender.find('.property:not(.init)').each(function () {
                                GetPropertyImageGallery($(this));
                            });
                        });
                    }, 10);
                }
                else {
                    _self.$context.data('is-busy', false);
                }

                if (data.PageNumber <= 1 && !_self._disableOwlCarousel) {
                    setTimeout(function () {
                        _self.$context.data('position', 0);
                        _self.$context.data('page', data.PageNumber);
                        _self.$context.data('page-count', data.PageCount);
                        _self.$context.data('page-size', data.PageSize);
                        _self.$context.data('is-busy', false);

                        getFirstElementChecked();

                        _self.$context.on('initialized.owl.carousel', function () {
                            _self.$sender.find('.property:not(.init)').each(function () {
                                GetPropertyImageGallery($(this));
                            });
                            $(document).trigger('enable-converter');
                        });
                        _self.$context.on('refreshed.owl.carousel', function () {
                            _self.$sender.find('.property:not(.init)').each(function () {
                                GetPropertyImageGallery($(this));
                            });
                            $(document).trigger('enable-converter');
                        });
                        _self.$context.on('changed.owl.carousel', function (e) {
                            if (e.property && e.property.name == "position" && _self.$context.data('position') < e.property.value) {
                                _self.$context.data('position', parseInt(e.property.value));
                                _self.$context.trigger('next');
                            }
                        });


                        if (_itemShow == 'undefined' || isNaN(_itemShow)) {
                            _itemShow = 3;
                        }

                        _self.$context.owlCarousel({
                            loop: false,
                            margin: 10,
                            lazyLoad: true,
                            items: _itemShow,
                            nav: true,
                            navText: ["<i class='aga aga-keyboard-arrow-left'></i>", "<i class='aga aga-keyboard-arrow-right'></i>"],
                            dots: false,
                            responsiveClass: true,
                            responsive: _self._stage
                        });
                        //_bindScrollerTrigger($context, $next, data.PageNumber, data.PageCount);
                    }, 60);
                } else {
                    _self.$context.data('is-busy', false);
                    //$sender.find('.property:not(.init)').each(function () {
                    //    GetPropertyImageGallery($(this));
                    //});
                }
            }

        });
    }
}

function EnableSlider() {
    var $sliders = $('[data-owl-slider]');
    $sliders.each(function () {
        new _createSlider(this);
    });

    function _createSlider(sender) {
        var _gallerySlider = null;
        var dataResponsive = $(".owl-slider").attr("data-responsive");
        if (dataResponsive != undefined) {
            var array = dataResponsive.split(',').map(Number);
            var len = array.length;
            if (len == 4) {
                _gallerySlider = { margin: 1, responsive: { 0: { items: array[0], nav: true }, 640: { items: array[1], nav: true }, 1024: { items: array[2], nav: true }, 1280: { items: array[3], nav: true, loop: false } } };
            }
        }
        var _property = { margin: 8, responsive: { 0: { items: 1, nav: true }, 640: { items: 2, nav: true }, 1024: { items: 3, nav: true, loop: false } } };
        var _gallery = { margin: 1, responsive: { 0: { items: 1, nav: true }, 640: { items: 2, nav: true }, 1024: { items: 3, nav: true, loop: false } } };
        var _custom = { margin: 8, responsive: { 0: { items: 1, nav: true }, 640: { items: 2, nav: true }, 840: { items: 3, nav: true, loop: false } } };
        var _customdots = { margin: 8, responsive: { 0: { items: 1, dots: true, nav: true }, 640: { items: 2, dots: true, nav: true }, 1024: { items: 3, nav: true, dots: true, loop: false } } };
        var _fullwidth = { margin: 8, responsive: { 0: { items: 1, dots: true, nav: true }, 640: { items: 2, dots: true, nav: true }, 1024: { items: 3, dots: true, nav: true }, 1200: { items: 4, nav: true, dots: true, loop: false } } };
        var _home = { margin: 8, responsive: { 0: { items: 1, nav: true }, 1024: { items: 2, nav: true, loop: false }, 1400: { items: 3, nav: true, loop: false } } };

        var _settings = { property: _property, gallery: _gallery, custom: _custom, customdots: _customdots, fullwidth: _fullwidth, home: _home };
        var _self = sender;
        _self.$this = $(sender);
        _self.key = _self.$this.data('owl-slider');
        _self.margin = _settings[_self.key].margin;
        if (_gallerySlider != null) {
            _self.responsive = _gallerySlider.responsive;
        } else {
            _self.responsive = _settings[_self.key].responsive;
        }
        _self.autoplay = _self.$this.data('owl-slider-autoplay');
        _self.autoplayTimeout = _self.$this.data('owl-slider-timeout');
        _self.loop = _settings[_self.key].loop;
        if ((_self.key == 'custom') || (_self.key == 'customdots') || (_self.key == 'fullwidth')) {
            var _settingsLoop = _self.$this.data('owl-slider-loop');
            if (typeof (_settingsLoop) != 'undefined') {
                _self.loop = _settingsLoop;
                for (var _key in _self.responsive) _self.responsive[_key].loop = _self.loop;
            }
            var _settingsMargin = _self.$this.data('owl-slider-margin');
            if (typeof (_settingsMargin) != 'undefined') {

                _self.margin = _settingsMargin;
            }
            var _settingsResponsive = _self.$this.data('owl-slider-responsive');
            if (typeof (_settingsResponsive) != 'undefined') {
                var _items = _settingsResponsive.split(',');
                var _i = 0;
                for (var _key in _self.responsive)
                    _self.responsive[_key].items = _items[_i++];
            }
            var _settingsAutoplay = _self.$this.data('owl-slider-autoplay');
            if (typeof (_settingsAutoplay) != 'undefined') {
                _self.autoplay = _settingsAutoplay;
                _self.autoplayTimeout = _self.$this.data('owl-slider-timeout');
            }
        }

        _self.$this.on('initialized.owl.carousel', function () {
            //_self.$this.find('.property:not(.init)').each(function () {
            //    GetPropertyImageGallery($(this));
            //});
            $(document).trigger('enable-converter');
        });

        _self.$this.on('loaded.owl.lazy', function () {
            _self.$this.find('.owl-item.active .property:not(.init)').each(function () {
                GetPropertyImageGallery($(this));
            });
        });
        var _options = {};
        var _optionsGiven = _self.$this.data('owl-slider-options');
        if (typeof (_optionsGiven) != 'undefined') {
            _optionsGiven = _optionsGiven.replace(/\'/gi, "\"");
            _options = $.parseJSON(_optionsGiven);
        }
        _self.$this.owlCarousel($.extend({
            margin: _self.margin,
            lazyLoad: true,
            nav: true,
            navText: ["<i aria-label='left' class='aga aga-keyboard-arrow-left'></i>", "<i aria-label='right' class='aga aga-keyboard-arrow-right'></i>"],
            dots: false,
            autoplay: _self.autoplay,
            autoplayTimeout: _self.autoplayTimeout,
            responsiveClass: true,
            loop: true,
            responsive: _self.responsive
        }, _options));
    }
}


function SubmitRequest(sender, type, formXml, success, error, idle) {
    if (sender != null) {
    }
    if (sender.parents('[data-request]').is('[data-brt-track]')) {
        var _formJson = '"form":' + JSON.stringify(getBRTContact(sender.parents('[data-request][data-brt-track]')));
        if (sender.parents('[data-request="RequestShowing"][data-brt-track]').is('[data-requesteddatetime]')) _formJson += ',"requesteddatetime":"' + sender.parents('[data-request][data-brt-track]').attr('data-requesteddatetime') + '"';
        var _formEvent = getBRTEvents(sender.parents('[data-request][data-brt-track]'));
    }
    $.ajax({
        type: 'POST',
        url: ((isMultiLingual() ? '/' + getLocale() : '')) + '/services/agoraRequest.ashx?action=' + ((type != undefined && type != null && type != '') ? type : 'none'),
        data: ({ lead: formXml }),
        dataType: 'json',
        success: function (response) {
            //if (reCaptchaAgora)
            //    reCaptchaAgora.reset();
            switch (response.Number) {
                case 100: // Success
                    if (success != undefined && success != null) {
                        success(sender, response);
                        return;
                    }
                    break;
                case 1: // Connection Error
                    if (error != null) {
                        error(sender, response);
                        return;
                    }
                    ShowAlert('Unable to submit your request at the moment. Please try again later.', 3000, 'alert_box', null);
                    break;
                case 2: // Execute Error
                    if (error != null) {
                        error(sender, { response: response });
                        return;
                    }
                case 403: // Execute Error
                    if (error != null) {
                        error(sender, { response: response });
                        return;
                    }
                    ShowAlert('Unable to submit your request at the moment. Please try again later.', 3000, 'alert_box', null);
                    break;
                case 9: // Custom Error
                    if (error != null) {
                        error(sender, response);
                        return;
                    }
                    ShowAlert(response.Message, 3000, 'alert_box', null);
                    break;
                case 10: // Invalid
                    if (error != null) {
                        error(sender, response);
                        return;
                    }
                    ShowAlert('Unable to submit your request at the moment. Please try again later.', 3000, 'alert_box', null);
                    break;
                case 201: // Captcha Error
                    if (error != null) {
                        error(sender, response);
                        return;
                    }
                case 202:
                    if (success != undefined && success != null) {
                        success(sender, response);
                        //if (reCaptchaAgora) {
                        //    reCaptchaAgora.active();
                        //}
                        return;
                    }
                    break;
                case 203:
                    if (idle != undefined && idle != null) {
                        //idle(sender, response);
                        //if (reCaptchaAgora) {
                        //    reCaptchaAgora.active();
                        //}
                        error(sender, response);
                        return;
                    }
                    break;
                case 204:
                    ShowAlert('SMS Gateway email addresses, which send email as text messages, are not permitted. Please enter a standard email address.', 2000, 'alert_box', null); sender.trigger('disengage');
                    break;
            }
        },
        error: function (response) {
            if (error != null) {
                error(sender, response);
                //if (reCaptchaAgora)
                //    reCaptchaAgora.reset();
                return;
            }

            ShowAlert('Unknown Error. Please try later!', 3000, 'alert_box', null);
        },
        statusCode: {
            404: function () {
                ShowAlert('Service (agoraRequest) not found!', 3000, 'alert_box', null);
            }
        }
    });
}

function GetSearchPrefixForRecordType(recordType) {
    switch (recordType) {
        case 'PROPERTY': return GetPrefixUrlForTerm('/property-search-map')+'/property-search-map';
        case 'PROPERTYRENT': return GetPrefixUrlForTerm('/property-search-map-on-rent') + '/property-search-map-on-rent';
        case 'PROPERTYSOLD': return GetPrefixUrlForTerm('/property-search-map/sold') + '/property-search-map/sold';
        case 'AGENT': return GetPrefixUrlForTerm('/real-estate-agents') + '/real-estate-agents';
        case 'OFFICE': return GetPrefixUrlForTerm('/real-estate-offices') + '/real-estate-offices';
        case 'BLOG': return GetPrefixUrlForTerm('/blog/search') + '/blog/search';
        case 'AGENTTEAM': return GetPrefixUrlForTerm('/real-estate-agents') + '/real-estate-agents';
    }
    return '/';
}

function GetSearchPrefixResulForRecordType(recordType) {
    switch (recordType) {
        case 'PROPERTY': return GetPrefixUrlForTerm('/homes/sale') + '/homes/sale';
        case 'PROPERTYRENT': return GetPrefixUrlForTerm('/property-search-map-on-rent') + '/property-search-map-on-rent';
        case 'PROPERTYSOLD': return GetPrefixUrlForTerm('/property-search-map/sold') + '/property-search-map/sold';
        case 'AGENT': return GetPrefixUrlForTerm('/real-estate-agents') + '/real-estate-agents';
        case 'OFFICE': return GetPrefixUrlForTerm('/real-estate-offices') + '/real-estate-offices';
        case 'BLOG': return GetPrefixUrlForTerm('/blog/search') + '/blog/search';
        case 'AGENTTEAM': return GetPrefixUrlForTerm('/real-estate-agents') + '/real-estate-agents';
    }
    return '/';
}

function GetDefaultSortForRecordType(recordType) {
    switch (recordType) {
        case 'PROPERTY': return '/dsort-p';
        case 'PROPERTYRENT': return '/dsort-p';
        case 'AGENT': return '/sort-n';
        case 'AGENTTEAM': return '/sort-n';
        case 'OFFICE': return '/sort-n';
    }
    return '';
}


//Perform Action Extented for MDL POP Up
$(document).on('click', '[data-perform-action]', function (event) {
    var triggerElement = $(this);
    if (triggerElement.prop('disabled')) {
        return;
    }
    triggerElement.prop('disabled', true);
    setTimeout(function () {
        triggerElement.prop('disabled', false);
    }, 2000);
    _performAction($(this));
});
$(document).on('tap', '[data-perform-action]', function (event) {
    _performAction($(this));
});
function _performAction(item) {
    var $this = item;
    var _actionType = $this.data('perform-action');
    var _actionUrl = $this.data('perform-action-url');
    var _urlQuery = $('#hdnurlquery').val();

    switch (_actionType) {
        case "SaveSearch":
            var type = $('[data-save-search-type]').data('save-search-type');
            var urlQuery = $('[data-save-search-url]').data('save-search-url');
            _actionUrl = _actionUrl + '&type=' + type + '&q=' + urlQuery;
            break;
        case "SaveListing":
            break;
    }
    PerformAction(_actionType, _actionUrl);
}


function IsNotNull(Value) {
    return Value != null && Value != undefined && Value.length > 0 && Value != "0" && Value != 0;
}

function IsNotNullOrIsZero(Value) {
    return Value != null && Value != undefined && Value.length > 0;
}

function isValideEmail(email) {
    var regex = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    return regex.test(email);
}

$(document).on('click', '[data-website-update-profile]', null, function () {
    var $sender = $(this);
    var $senderForm = $sender.parents('[data-request]');
    $sender.addClass('loading');
    var _phone = $senderForm.find('[node="MobilePhone"]').val();
    _phone = IsNotNull(_phone) ? _phone.replace(/[^0-9]/gi, '') : _phone;
    if (IsNotNull(_phone) && _phone.length < 10) { ShowAlert('Please enter a 10-digit phone number. For example: (123) 123-1234', 3000, 'alert_box', null); $sender.removeClass('loading'); return; }
    if ($senderForm.find('#Password').val() != $senderForm.find('#Confirm_Password').val()) { alert('Password mismatch !'); $sender.removeClass('loading'); return; }
    var _formXML = GetFormXml($senderForm);
    $.ajax({
        type: 'POST',
        url: '/services/agoraDashboardAction.ashx',
        data: ({ ActionType: 'UpdateUserDetail', contact: _formXML }),
        dataType: 'json',
        success: function (result) {
            if (result.Status == 1) {
                $sender.parents('[data-request][data-brt-track]').trigger('success');
                if (result.Contact)
                    document.body.dispatchEvent(new CustomEvent('ag.user.in', { detail: result.Contact }));
                ShowAlert('Your account profile has been updated successfully.', 3000, 'alert_box', null);
                window.location.reload();
            }
            else {
                ShowAlert("Failed, please try again later.", 3000, 'alert_box', null);
            }
        },
        statusCode: {
            404: function () {
                ShowAlert('Sorry for the inconvenience this facility is currently unavailable please try later.', 3000, 'alert_box', null);
            }
        }
    });
    setTimeout(function () { $sender.removeClass('loading'); }, 200);
});

function GetPropertyImageGallery($this) {
    var $itemContext = $this;
    var $slideContext = $itemContext.find('.slides');
    $slideContext.attr('data-css-slider', '0');
    var mlsNumber = $itemContext.find('[data-mk]').data('mk');
    var mlsBoard = $itemContext.find('[data-mlsboard]').data('mlsboard');
    var url = $itemContext.find('[data-detail-url]').data('detail-url');
    var projectCode = $('[data-pcode]').data('pcode');
    var imageTemplate = $itemContext.find('[data-mls-photo]').data('mls-photo');
    var nativeTab = $itemContext.find('[data-native-tab]').data('native-tab');
    if (!IsNotNull(imageTemplate)) imageTemplate = '/images/company/' + projectCode + '/NoPhotoImage/image-not-found.jpg';
    var count = parseInt($slideContext.data('value'), 10);
    var $itemWithIDContext = $itemContext.closest('[id]');
    var uID = $itemContext.length == 0 ? "un" : $itemWithIDContext.attr('id').replace(/\$/gi, '');
    buildFirstTemplate(imageTemplate, count, uID + new Date().getMilliseconds(), mlsBoard, mlsNumber, $slideContext, url, nativeTab);
    $itemContext.addClass('init');
}

function buildFirstTemplate(template, count, uID, mlsBoard, mlsNumber, $slideContext, url, nativeTab) {
    var i = 0, prefix = (uID + mlsBoard + mlsNumber + '_');
    $('<input type="radio" aria-label="' + (prefix + 'slider') + '"  name="' + (prefix + 'slider') + '" id="' + (prefix + i) + '" checked />').appendTo($slideContext);
    var $navigations = $('<div class="nav"></div>');
    //var $next = $('<label data-css-slider-nav="propphoto" for="' + (prefix + (i + 1)) + '" class="next"></label>');
    //var $prev = $('<label data-css-slider-nav="propphoto" for="' + (prefix + (parseInt(count, 10) - 1)) + '" class="prev"></label>');
    var $next = $('<label aria-label="Next slide" data-css-slider-nav="propphoto" for="' + (prefix + (i + 1)) + '"  class="next"><span class="visuallyhidden">Next Slide</span></label>');
    var $prev = $('<label aria-label="Previous Slide" data-css-slider-nav="propphoto" for="' + (prefix + (parseInt(count, 10) - 1)) + '" class="prev"><span class="visuallyhidden">Previous slide</span></label>');

    $prev.on('click', _loadMore);
    $next.on('click', _loadMore);
    $prev.appendTo($navigations);
    $next.appendTo($navigations);
    if ($('[data-pcode]').data('pcode') == 'PSB') { var target = ''; } else { var target = 'target = "_blank"'; }
    if (nativeTab != 'undefined' && nativeTab != '' && nativeTab == 1)
        target = '';
    var $node = $('<li class="slide-container" aria-roledescription="carousel"><div class="slide"><div class="Prop_img" role="img" aria-label="bannerImage"  style="background-image:url(\'' + template + '\');"><a aria-label="' + (prefix + 'slider') + '"' + target + 'href="' + url + '"></a></div></div></li>');
    $node.append($navigations);
    $node.appendTo($slideContext);
    function _loadMore() {
        var $sender = $(this);
        $prev.off('click');
        $next.off('click');
        $.ajax({ url: '/services/agoraPropertyPhotos.aspx', data: { mlsboard: mlsBoard, mlsno: mlsNumber, container: prefix }, success: function (response) { $slideContext.append(response); $sender.trigger('click'); } });
    }
}

function getPhoto(count, i, template) {
    if (IsNotNull(template)) {
        return template.replace(String(template.match(/\_[0-9]+\./g)), "_" + i + ".") + "?mw=800&amp;mh=480";
    } else {
        return "/images/NoPhotoImage/image-not-found.jpg";
    }
}

$(document).on("click", '[data-css-slider-nav]', null, function () {
    var $self = $(this);
    var val = $self.attr('for');
    var $control = $self.closest('[data-css-slider]').find('[data-id="' + val + '"]');
    $control.attr("style", $control.data('src'));
});


function EnableDemandImport() {
    _init();
    function _init() {
        $("img[data-demand-key]").each(function () {
            GetProperties($(this), $(this).data('demand-url'), $(this).data('demand-key'), $(this).data('layout'));
        });
    }
    $(document).on('click', '[data-ck-href]', null, function () {
        GetProperties($(this).parents('[data-ck-propertylist]:first'), $(this).data('ck-href'), $(this).parents('[data-ck-propertylist]:first').data('ck-demand-key'), $(this).parents('[data-ck-propertylist]:first').data('ck-demand-layout'));
    });


    $(document).on('change', '[data-ck-propertylist] [data-sort-object="CMNCMN"]', {}, function () {
        GetProperties($(this).parents('[data-ck-propertylist]:first'), $(this).parents('[data-ck-property-url]:first').data('ck-property-url'), $(this).parents('[data-ck-propertylist]:first').data('ck-demand-key'), $(this).parents('[data-ck-propertylist]:first').data('ck-demand-layout'));
    });

    function GetProperties($this, url, demandKey, layout) {
        var isEditMode = $this.closest('div[contenteditable]').attr('contenteditable');
        if (!isEditMode && typeof (url) != 'undefined' || typeof (demandKey) != 'undefined') {
            //ShowLoading();
            layout = (typeof (layout) != 'undefined' ? layout : "gallery");
            switch (layout.toLowerCase()) {
                case "gallery":
                    var $sort = $this.find('[data-sort-object="CMNCMN"]');
                    if (($sort != 'undefined' && $sort != null && $sort.length > 0) || !url.match(/(^|\/)(d)?sort\-[a-z]+/g))
                        url = (_getCMNCMNSortBy($this) + '/' + (url.replace('http://', '').replace(/(^|\/)(d)?sort\-[a-z]+/g, ''))).replace('//', '/');
                    $.ajax({
                        type: 'POST',
                        url: '/services/agoraGetGalleryView.aspx',
                        data: { UrlQuery: url, TypeOfSearch: 'SALE', IsContentPage: "true", DemandKey: demandKey },
                        dataType: 'html',
                        success: function (response) {
                            var isEditMode = $this.closest('div[contenteditable]').attr('contenteditable');
                            if (!isEditMode) {
                                var $html = '<section class="result-page" data-ck-propertylist="" data-ck-demand-key="' + demandKey + '" data-ck-property-url="' + url + '" data-ck-demand-layout="' + layout + '">' + response + '</section>';
                                $this.after($html);
                                $this.remove();
                                if (!(typeof (componentHandler) == 'undefined')) {
                                    componentHandler.upgradeDom();
                                }
                                //$('#propertyGrid').find('.property:not(.init)').each(function () {
                                //    GetPropertyImageGallery($(this));
                                //});
                                $('[data-ck-demand-key="' + demandKey + '"] #propertyGrid').each(function () {
                                    $(this).find('.property:not(.init)').each(function () {
                                        GetPropertyImageGallery($(this));
                                    });
                                });
                                //ShowLoading();
                            }
                        },
                        error: function () {
                            ShowLoading();
                        }
                    });
                    break;
                case "carousel":
                    $.ajax({
                        type: 'POST',
                        url: '/services/agoraGetCarouselItem.aspx',
                        data: { UrlQuery: url, TypeOfSearch: 'SALE', IsContentPage: "true", DemandKey: demandKey },
                        dataType: 'html',
                        success: function (response) {
                            var isEditMode = $this.closest('div[contenteditable]').attr('contenteditable');
                            if (!isEditMode) {
                                var $html = '<section class="result-page" data-ck-propertylist="" data-ck-demand-key="' + demandKey + '" data-ck-property-url="' + url + '" data-ck-demand-layout="' + layout + '">' + response + '</section>';
                                $this.after($html);
                                $('[data-query-list]:not(.init)[data-service-url][data-rt^="CMN"]').each(function () {
                                    $(this).trigger('init');
                                    $(this).addClass('init');
                                });
                                $this.remove();
                                if (!(typeof (componentHandler) == 'undefined')) {
                                    componentHandler.upgradeDom();
                                }
                                //ShowLoading();
                            }
                        },
                        error: function () {
                            ShowLoading();
                        }
                    });
                    break;
            }
        }
    }

    function _getCMNCMNSortBy($parent) {
        var $sort = $parent.find('[data-sort-object="CMNCMN"]');
        if ($sort != 'undefined' && $sort != null && $sort.length > 0 && IsNotNull($sort.val())) {
            return $sort.val();
        }
        return GetDefaultSortForRecordType('PROPERTY');
    }
}

function EnableHJNImport() {
    _hjInit();
    var _prevScrollTop = jQuery(window).scrollTop();
    function _hjInit() {
        $("img[data-demograhics]:not(img[data-init-completed])").each(function () {
            var $self = $(this);
            var isEditMode = $self.closest('div[contenteditable]').attr('contenteditable');
            if (!isEditMode) {
                if (isOnScreen($self)) {
                    $self.attr('data-init-completed', "1");
                    GetHJN($self, $self.data('hjn-id'));
                }
                else {
                    $(window).scroll(function () {
                        if ((jQuery(window).scrollTop() > _prevScrollTop && jQuery(window).scrollTop() - _prevScrollTop < 10) || (_prevScrollTop > jQuery(window).scrollTop() && _prevScrollTop - jQuery(window).scrollTop() < 10)) return;
                        _prevScrollTop = jQuery(window).scrollTop();
                        if (isOnScreen($self) && !$self.attr('data-init-completed')) {
                            GetHJN($self, $self.data('hjn-id'));
                            $self.attr('data-init-completed', "1");
                        }
                    });
                }
            }
        });
    }
}

function GetHJN($this, hjnId) {
  
    var date = new Date();
    var _containerIdSufix = date.getFullYear() + ("0" + (date.getMonth() + 1)).slice(-2) + ("0" + date.getDate()).slice(-2) + ("0" + date.getHours() + 1).slice(-2) + ("0" + date.getMinutes()).slice(-2) + ("0" + date.getSeconds()).slice(-2) + ("0" + date.getMilliseconds()).slice(-2);
   
    $.ajax({
        
        url: '/services/agoraDemographicsWidget.aspx',
        data: { 'hjnId': hjnId, containerIdSufix: _containerIdSufix },
        type: 'GET',
        dataType: 'html',
        success: function (result) {
            var isEditMode = $this.closest('div[contenteditable]').attr('contenteditable');
            if (!isEditMode) {
                $this.after(result);
                $this.remove();
                if (!(typeof (componentHandler) == 'undefined')) {
                    componentHandler.upgradeDom();
                }
            }
        },
        error: function () {
        }
    });
}
function getDocHeight(doc) {
    doc = doc || document;
    var body = doc.body, html = doc.documentElement;
    var height = Math.max(body.scrollHeight, body.offsetHeight,
        html.clientHeight, html.scrollHeight, html.offsetHeight);
    return height;
}

function resetIframeHeight(ifrm) {
    var doc = ifrm.contentDocument ? ifrm.contentDocument :
        ifrm.contentWindow.document;
    //console.log(getDocHeight(doc)  + "px");
    $(ifrm).height(getDocHeight(doc) + "px");
}
function isOnScreen(elem) {
    if (elem.length == 0) {
        return;
    }
    var $window = jQuery(window);
    var viewport_top = $window.scrollTop();
    var viewport_height = $window.height();
    var viewport_bottom = viewport_top + viewport_height;
    var $elem = jQuery(elem);
    var top = $elem.offset().top;
    var height = $elem.height();
    var bottom = top + height;

    return (top >= viewport_top && top < viewport_bottom) ||
        (bottom > viewport_top && bottom <= viewport_bottom) ||
        (height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)
}
function EnableYelpImport() {
    _yelpInit();
    var _prevScrollTop = jQuery(window).scrollTop();
    function _yelpInit() {
        $('img[data-yelp-control]:not(img[data-init-completed]').each(function () {
            var $self = $(this);
            var isEditMode = $self.closest('div[contenteditable]').attr('contenteditable');
            if (!isEditMode) {
                if (isOnScreen($self)) {
                    $self.attr('data-init-completed', "1");
                    processYelpControlSearch($self);
                }
                else {
                    $(window).scroll(function () {
                        if ((jQuery(window).scrollTop() > _prevScrollTop && jQuery(window).scrollTop() - _prevScrollTop < 10) || (_prevScrollTop > jQuery(window).scrollTop() && _prevScrollTop - jQuery(window).scrollTop() < 10)) return;
                        _prevScrollTop = jQuery(window).scrollTop();
                        if (isOnScreen($self) && !$self.attr('data-init-completed')) {
                            $self.attr('data-init-completed', "1");
                            processYelpControlSearch($self);
                        }
                    });
                }
            }
        });
    }
}
function processYelpControlSearch($sender) {
    var location = $sender.data('location');
    var latitude = $sender.data('latitude');
    var longitude = $sender.data('longitude');
    var date = new Date();
    var _containerIdSufix = date.getFullYear() + ("0" + (date.getMonth() + 1)).slice(-2) + ("0" + date.getDate()).slice(-2) + ("0" + date.getHours() + 1).slice(-2) + ("0" + date.getMinutes()).slice(-2) + ("0" + date.getSeconds()).slice(-2) + ("0" + date.getMilliseconds()).slice(-2);
    $.ajax({
        url: '/services/agoraYelpWidget.aspx',
        data: { 'location': location, 'latitude': latitude, 'longitude': longitude, containerIdSufix: _containerIdSufix },
        type: 'GET',
        dataType: 'html',
        success: function (result) {
            var isEditMode = $sender.closest('div[contenteditable]').attr('contenteditable');
            if (!isEditMode) {
                $sender.after(result);
                $sender.remove();
                if (!(typeof (componentHandler) == 'undefined')) {
                    componentHandler.upgradeDom();
                }
                $(".yelp-import-result-" + _containerIdSufix).find(".owl-carousel").owlCarousel({
                    items: 4, // THIS IS IMPORTANT
                    nav: true,
                    navText: ["<i class='aga-keyboard-arrow-left'></i>", "<i class='aga-keyboard-arrow-right'></i>"],
                    responsive: {
                        0: { items: 1 },
                        480: { items: 1 }, // from zero to 480 screen width 4 items
                        768: { items: 2 }, // from 480 screen widthto 768 6 items
                        1024: {
                            items: 4   // from 768 screen width to 1024 8 items
                        }
                    },
                });
            }
        },
        error: function () {
        }
    });
}

function EnableAreaMapImport() {
    _areamapInit();
    var _prevScrollTop = jQuery(window).scrollTop();
    function _areamapInit() {
        $('img[data-areamap-control]:not(img[data-init-completed]').each(function () {
            var $self = $(this);
            var isEditMode = $self.closest('div[contenteditable]').attr('contenteditable');
            if (!isEditMode) {
                if (isOnScreen($self)) {
                    $self.attr('data-init-completed', "1");
                    getAreaMapControl($self);
                }
                else {
                    $(window).scroll(function () {
                        if ((jQuery(window).scrollTop() > _prevScrollTop && jQuery(window).scrollTop() - _prevScrollTop < 10) || (_prevScrollTop > jQuery(window).scrollTop() && _prevScrollTop - jQuery(window).scrollTop() < 10)) return;
                        _prevScrollTop = jQuery(window).scrollTop();
                        if (isOnScreen($self) && !$self.attr('data-init-completed')) {
                            $self.attr('data-init-completed', "1");
                            getAreaMapControl($self);
                        }
                    });
                }
            }
        });
    }
}
function getAreaMapControl($sender) {
    var latitude = $sender.data('latitude');
    var longitude = $sender.data('longitude');
    $.ajax({
        url: '/services/agoraAreaMapWidget.aspx',
        data: { 'latitude': latitude, 'longitude': longitude },
        type: 'GET',
        dataType: 'html',
        success: function (result) {
            var isEditMode = $sender.closest('div[contenteditable]').attr('contenteditable');
            if (!isEditMode) {
                $sender.after(result);
                $sender.remove();
                if (!(typeof (componentHandler) == 'undefined')) {
                    componentHandler.upgradeDom();
                }
            }
        },
        error: function () {
        }
    });
}

function EnableConverter() {
    var _converterID = 1;
    if (typeof (AgoraCurrencyConvertions) != 'undefined' && AgoraCurrencyConvertions != null) {
        _init();
        $(document).on('enable-converter', _enableConverter);
        _enableConverter();
    }

    function _init() {
        $('[data-currency-converter-master]').each(function () {
            var $handle = $(this);
            $handle.html(_getConvertionControl());
            $handle.find('[data-converter-options]').on('change', function (e) {
                _setConverter($(this));
                _updateMasterValue($handle);
                $('[data-converter]').trigger('update');
            });
            _updateMasterValue($handle);
        });
    }

    function _enableConverter() {
        if (!(typeof (AgoraCurrencyConvertions) != 'undefined' && AgoraCurrencyConvertions != null)) return;
        $('[data-converter]:not([data-is-upgraded]),[data-converter][data-is-template]').each(function (index, element) {
            var $placeholder = $(element);
            var $state = $('<label data-converter-handle="" for="converter_' + _converterID + '"></label>');
            var $contextHTML = $('<div></div>');
            $contextHTML.append($('<div data-converter-control=""></div>').append($('<b data-converter-value="" class="bg-lg"></b>').append($placeholder.html())).append($state));
            $placeholder.html($contextHTML.html());
            _converterID++;
            $placeholder.on('update', function (e) {
                _convertValue($(this).closest('[data-converter]'));
            });

            $placeholder.attr('data-is-upgraded', 'true');
            //$placeholder.find('a i').on('click', function () { if (!$(this).parent().hasClass('active')) $(this).parent().addClass('active'); else $(this).parent().removeClass('active'); });
            $placeholder.trigger('update')
        });
    }


    function _getConvertionControl() {
        if (AgoraCurrencyConvertions && AgoraCurrencyConvertions != null && AgoraCurrencyConvertions.ExchangeRate && AgoraCurrencyConvertions.ExchangeRate.Rates && AgoraCurrencyConvertions.ExchangeRate.Rates.length > 0) {
            var $control = $('<select data-converter-options=""></select>');
            for (var key in AgoraCurrencyConvertions.ExchangeRate.Rates) {
                $('<option value=\"' + AgoraCurrencyConvertions.ExchangeRate.Rates[key].Code + '\" data-currency=\"' + AgoraCurrencyConvertions.ExchangeRate.Rates[key].Code + '\"  data-currency-constant=\"' + AgoraCurrencyConvertions.ExchangeRate.Rates[key].Constant + '\" ' + (AgoraCurrencyConvertions.ExchangeRate.Rates[key].Notation && AgoraCurrencyConvertions.ExchangeRate.Rates[key].Notation != '' ? ' data-currency-notation=\"' + AgoraCurrencyConvertions.ExchangeRate.Rates[key].Notation + '\"' : '') + '>' + AgoraCurrencyConvertions.ExchangeRate.Rates[key].Name + '</option>').appendTo($control);
            }
            return $control;
        }
        return '';
    };

    function _setConverter(sender) {
        var $current = $(sender).find('option:selected');
        var _constant = $current.data('currency-constant');
        var _code = $current.data('currency');
        var _notation = $current.data('currency-notation');
        var _haveNotation = typeof (_notation) != 'undefined' && _notation != null && _notation != '';
        setCookie('_converter_constant', _constant, 30);
        setCookie('_converter_representation', _haveNotation ? _notation : '', 30);
        setCookie('_converter_code', _code, 30);
        try {
            $(sender).blur();
        } catch (e) { }
    }

    function _convertValue(converter) {
        var $converter = $(converter);
        var $handle = $converter.find('[data-converter-handle]');
        var $select = $converter.find('[data-converter-options]');
        var $value = $converter.find('[data-converter-value]');
        var _intermediateCode = getCookie('_converter_code');
        var _intermediateConstant = getCookie('_converter_constant');
        var _intermediateRepresentation = getCookie('_converter_representation');
        var _hideCurrencyCode = getCookie('_converter_hide_currenycode');
        var _constant = _intermediateCode == '' ? 1 : _intermediateConstant;
        var _representation = _intermediateCode == '' ? '$' : _intermediateRepresentation;
        var _code = _intermediateCode == '' ? 'USD' : _intermediateCode;
        var _hideCode = _hideCurrencyCode == '' ? '0' : _hideCurrencyCode;
        _hideCode != '1' ? $handle.attr('data-converter-handle', _code) : '';
        $select.val(_code);
        _update(_constant, _representation, _code);
        function _update(constant, representation, code) {
            if (constant != null && code != null && constant != '' && code != '') {
                try {
                    var _value1 = parseFloat($converter.data('converter'));
                    var _value2 = parseFloat(constant);
                    var _value3 = _value1 * _value2;
                    var _valuePart = Math.floor(_value3).toString().replace(/(\d)(?=(\d{3})+$)/g, '$1,');
                    $value.text((representation != '' ? representation : '') + '' + _valuePart);
                } catch (e) { console.log(e); $value.text('N/A'); }
            }
        }
    };

    function _getAgoraExchangeItem(code) {
        for (var key in AgoraCurrencyConvertions.ExchangeRate.Rates) {
            if (AgoraCurrencyConvertions.ExchangeRate.Rates[key].Code == code)
                return AgoraCurrencyConvertions.ExchangeRate.Rates[key];
        }
        return null;
    }

    function _updateMasterValue(converter) {
        var $converter = $(converter);
        var $handle = $converter;
        var _intermediateCode = getCookie('_converter_code');
        var _default = $handle.data('currency-default');
        var $hideCode = $handle.data('hide-currencycode');
        if (_intermediateCode == '' && (typeof (_default) != 'undefined' && _default != '')) {
            var _agoraExchangeItem = _getAgoraExchangeItem(_default);
            if (_agoraExchangeItem != null) {
                _intermediateCode = _agoraExchangeItem.Code;
                var _haveNotation = typeof (_agoraExchangeItem.Notation) != 'undefined' && _agoraExchangeItem.Notation != null && _agoraExchangeItem.Notation != '';
                setCookie('_converter_constant', _agoraExchangeItem.Constant, 30);
                setCookie('_converter_representation', _haveNotation ? _agoraExchangeItem.Notation : '', 30);
                setCookie('_converter_code', _agoraExchangeItem.Code, 30);
                setCookie('_converter_hide_currenycode', $hideCode, 30);
            }
        }
        var $select = $converter.find('[data-converter-options]');
        var $value = $converter.find('[data-converter-value]');
        var _intermediateConstant = getCookie('_converter_constant');
        var _intermediateRepresentation = getCookie('_converter_representation');
        var _constant = _intermediateCode == '' ? 1 : _intermediateConstant;
        var _representation = _intermediateCode == '' ? '$' : _intermediateRepresentation;
        var _code = _intermediateCode == '' ? 'USD' : _intermediateCode;
        $handle.attr('data-converter-handle', _code);
        $select.val(_code);
    };

};

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
Date.prototype.yyyymmddhhmmss = function () {
    var yyyy = this.getFullYear();
    var mm = this.getMonth() < 9 ? "0" + (this.getMonth() + 1) : (this.getMonth() + 1); // getMonth() is zero-based
    var dd = this.getDate() < 10 ? "0" + this.getDate() : this.getDate();
    var hh = this.getHours() < 10 ? "0" + this.getHours() : this.getHours();
    var min = this.getMinutes() < 10 ? "0" + this.getMinutes() : this.getMinutes();
    var ss = this.getSeconds() < 10 ? "0" + this.getSeconds() : this.getSeconds();
    return "".concat(yyyy).concat(mm).concat(dd).concat(hh).concat(min).concat(ss);
};

function ReloadProperttypestate() {
    var val = $('[data-proptype] :selected').val();
    var selector = '[data-parent-val=' + '"' + val + '"]';
    $('[data-parent-val]').removeClass('mdl-cell--hide').addClass('mdl-cell--hide');
    $(selector).removeClass('mdl-cell--hide');

}

$(document).on('change', '[data-proptype]', {}, function () {
    $parent = $(this);
    var val = $('[data-proptype] :selected').val();
    var selector = '[data-parent-val=' + '"' + val + '"]';
    $('[data-parent-val]').removeClass('mdl-cell--hide').addClass('mdl-cell--hide');
    $('[data-parent-val] input[type="checkbox"]').each(function () {
        if ($(this).closest('.mdl-js-checkbox').length > 0) {
            $('#homePropTypeLabel').html($parent.attr("data-search-name-label") + ' (all)');
            $(this).closest('.mdl-js-checkbox')[0].MaterialCheckbox.uncheck();
        }
        else
            $(this).prop('checked', false);
    });

    $(selector).removeClass('mdl-cell--hide');
    doSearch(true);
});

function openYouTubeEmbedVideo(src, title) {
    $("#IwbPopUpArea").AgoraDialogModal({ ServiceUrl: '/PopUps/PlayEmbedYoutubeVideo.aspx?Title=' + title + '&Src=' + src, EnableAjaxHtmlLoad: true });
}

function EnableTabContents() {
    setTabContent(getLocationHref());
    $('[data-tab-url]').click(function () {
        var $dataCount = $('body').find('[data-content="' + $(this).data('tab-url') + '"]').length;
        if ($dataCount > 0) {
            setTabContent($(this).data('tab-url'));
            window.history.pushState("", "", "/" + $(this).data('tab-url'));
        }
        else { window.location.href = $(this).data('tab-url'); }
    });

    function getLocationHref() {
        var defaultItem = $('a[data-tab-url]')[0];
        var _href = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
        // return !isNullOrEmpty(_href) ? _href : $(defaultItem).data('tab-url');
        return (_href != null && _href.trim() !== '') ? _href : $(defaultItem).data('tab-url');
    }

    function setTabContent(url) {
        _setDefaults();
        $('[data-content="' + url + '"]').removeClass('mdl-cell--hide');
        $('a[data-tab-url="' + url + '"]').addClass('active-class');
    }

    function _setDefaults() {
        $('[data-content]').each(function () {
            if (!$(this).hasClass('mdl-cell--hide'))
                $(this).addClass('mdl-cell--hide');
        });
        $('a[data-tab-url]').each(function () {
            if ($(this).hasClass('active-class'))
                $(this).removeClass('active-class');
        });
    }

    window.addEventListener('popstate', function (event) {
        setTabContent(getLocationHref());
    });
}



function get_video_thumb(url, callback) {
    var id = get_video_id(url);
    if (id['type'] == 'y') {
        return processYouTube(id);
    } else if (id['type'] == 'v') {
        $.ajax({
            url: 'http://vimeo.com/api/v2/video/' + id['id'] + '.json',
            dataType: 'jsonp',
            success: function (data) {
                callback({ type: 'v', id: id['id'], url: data[0].thumbnail_large });
            }
        });
    }
    function processYouTube(id) {
        if (!id) { throw new Error('Unsupported YouTube URL'); }
        callback({ type: 'y', id: id['id'], url: 'https://i2.ytimg.com/vi/' + id['id'] + '/hqdefault.jpg' });
    }
}
function getYoutubeVideoId(url) {
    if (url.indexOf('youtube.com') > -1) {
        if (url.indexOf('v=') > -1) { id = url.split('v=')[1].split('&')[0]; }
        else if (url.indexOf('embed') > -1) { id = url.split('embed/')[1].split('?')[0]; };
        return id;
    }
}

function get_video_id(url) {
    var id;
    var a;
    if (url.indexOf('youtube.com') > -1) {
        if (url.indexOf('v=') > -1) { id = url.split('v=')[1].split('&')[0]; }
        else if (url.indexOf('embed') > -1) { id = url.split('embed/')[1].split('?')[0]; };
        return processYouTube(id);
    }
    else if (url.indexOf('youtu.be') > -1) { id = url.split(/v\/|v=|youtu\.be\//)[1].split(/[?&]/)[0]; return processYouTube(id); }
    else if (url.indexOf('vimeo.com') > -1) {
        if (url.match(/https?:\/\/(www\.)?vimeo.com\/(\d+)($|\/)/)) { id = url.split('/')[3]; }
        else if (url.match(/^vimeo.com\/channels\/[\d\w]+#[0-9]+/)) { id = url.split('#')[1]; }
        else if (url.match(/vimeo.com\/groups\/[\d\w]+\/videos\/[0-9]+/)) { id = url.split('/')[4]; }
        else if (url.match(/player.vimeo.com\/video\/[0-9]+/)) { id = url.split('/')[2]; }
        else { throw new Error('Unsupported Vimeo URL'); }
    }
    else { throw new Error('Unrecognised URL'); }
    a = { type: 'v', id: id };
    return a;
    function processYouTube(id) {
        if (!id) { throw new Error('Unsupported YouTube URL'); }
        a = { type: 'y', id: id };
        return (a); // default.jpg OR hqdefault.jpg
    }
}


function getSearchUrlTermValue(urlQuery, searchterm) {

    var _urlquerySplit = urlQuery.split('/');
    var _value = '';
    for (var i = 0; i < _urlquerySplit.length; i++) {
        if (_urlquerySplit[i].split('-')[0] == searchterm)
            _value = _urlquerySplit[i].split('-')[1];
    }
    return _value;
}

function removeTagAttibute(attributeName) {
    var allTags = '*';
    var specificTags = ['ARTICLE', 'INPUT', 'A', 'DIV', 'SELECT', 'INPUT', 'TEXTAREA'];

    var allelems = document.querySelectorAll(specificTags);
    for (i = 0, j = 0; i < allelems.length; i++) {
        allelems[i].removeAttribute(attributeName);
    }
}

function GetYoutubeVideoimage(embededURL) {
    if (IsNotNull(embededURL)) {
        var videoImage = '';
        var youtube_video_id = embededURL.match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/).pop();
        if (youtube_video_id.length == 11) {
            var videoImage = '//img.youtube.com/vi/' + youtube_video_id + '/0.jpg';
        }
        return videoImage
    }
}

function EnableGoogleSearch() {
    $(document).on('keydown', '[data-google-locationsearch="Enable"]', null, function () { EnableGoogleLocationSearch(); });
    $(document).on('keyup', '[data-google-locationsearch="Enable"]', null, function () { $('[data-google-locationsearch="Enable"]').removeAttr('placeholder'); });
}
function EnableGoogleLocationSearch() {
    var autocomplete = new google.maps.places.Autocomplete($('[data-google-locationsearch="Enable"]')[0], {});
}

window.onload = window.onresize = function () {
    setTimeout(EnableFlowlessHeader, 100);
};

function initMapDefault() {
    if (window.onMapLoaded) window.onMapLoaded();
}

function fixNavigationAfterGoogleTranslate() {
    if ($('select.goog-te-combo') == null) return;

    $('select.goog-te-combo').change(function () {
        setTimeout(function () {
            window.dispatchEvent(new Event('resize'));
        }, 1000);
    });
}

function normalizeMaterialControls(context) {
    var $context = $(context);
    //generic
    $context.find('[data-upgraded]').removeAttr('data-upgraded');
    $context.find('.is-upgraded').removeClass('.is-upgraded');
    //textfield

    //radio
    $context.find('.mdl-radio').children('*:not(input):not(.mdl-radio__label)').remove();

    //checkbox
    $context.find('.mdl-checkbox').children('*:not(input):not(.mdl-checkbox__label)').remove();

    //selectfield
    $context.find('.mdl-selectfield').children('*:not(select):not(label)').remove();

    setIDsAndNames($context);
    setTimeout(function () { resetIDsAndNames($context) }, 500);
}
function setIDsAndNames($container) {
    $container.find('[data-id]').each(function () {
        var $this = $(this);
        $this.attr('id', $this.attr('data-id'));
        $this.removeAttr('data-id');
    });
    $container.find('[data-name]').each(function () {
        var $this = $(this);
        $this.attr('name', $this.attr('data-name'));
        $this.removeAttr('data-name');
    });
}

function resetIDsAndNames($container) {
    $container.find('[id]').each(function () {
        var $this = $(this);
        $this.attr('data-id', $this.attr('id'));
        $this.removeAttr('id');
    });
    $container.find('[name]').each(function () {
        var $this = $(this);
        $this.attr('data-name', $this.attr('name'));
        $this.removeAttr('name');
    });
}

agora(function () {

    if ($(".footer-drop-items").length > 0) {
    $(document).click(function (e) {
        var container = $(".footer-drop-items");
        if (!container.is(e.target) &&
            !container.has(e.target).length) {
            container.find(".sidewardsDrop").css({ display: 'none' });
            $('.footer-drop-items input[type="radio"]').prop('checked', false);
        }
    });

    $('.footer-drop-items input[type="radio"]').change(function () {
        $(this).parent().find(".sidewardsDrop").css({ display: 'block' });
    });

    }

});


function uncheckDuplicates(urlIdentifier) {
    const checkedValues = [];
    const childCheckboxes = document.querySelectorAll(`[urlidentifier="${urlIdentifier}"]`);

    // Gather the checked values
    childCheckboxes.forEach(child => {
        if (child.checked) {
            checkedValues.push(child.value);
        }
    });

    const seenValues = new Set();


    childCheckboxes.forEach(child => {
        if (child.checked && checkedValues.includes(child.value)) {
            // If this value has been seen before, uncheck it
            if (seenValues.has(child.value)) {
                child.checked = false;
            } else {
                // Otherwise, mark this value as seen
                seenValues.add(child.value);
            }
        }
    });
}







document.body.addEventListener('ag.widget.no-data', function (e) {
    
    var node = e.detail.sender;
    var agLoaderAttr = node.getAttribute('ag-loader');
    if (!agLoaderAttr) return;
    var controllerAttr = agLoaderAttr + '_controller';
    var Widgets = document.querySelectorAll(`[${controllerAttr}]`);

    console.log("Widgets:", Widgets);
    
    if (node.hasAttribute('show-no-data')) {
        
            setTimeout(function () {
                
                if (!node.querySelector('.no-data-message')) {
                    node.innerHTML += `
                <span class="no-data-message"
                      style="
                          display: block;
                          padding-left: 0;
                          color: rgba(53, 53, 54, 0.96);
                          font-family: 'Poppins', 'Arial' !important;
                          font-weight: 600;
                          font-size: 16px;
                          font-style: normal;
                          margin-top: 20px;
                      ">
                    The data for this area is unavailable.
                </span>`;
                }


            }, 100); 
        }
        else {
        Widgets.forEach(function (Widget) {
            Widget.remove(); 
            });
        }
    
});












document.addEventListener("click", function (event) {
    let target = event.target;

   
    while (target && target !== document.documentElement) {
        if (isLabelOrLiWithController(target)) {
            handleEvent(event, target);
            break;
        }
        target = target.parentElement;
    }
});

function isLabelOrLiWithController(element) {
    return (element.tagName === "LABEL" || element.tagName === "LI") &&
        [...element.attributes].some(attr => attr.name.endsWith("_controller"));
}

function handleEvent(event, target) {
    event.stopPropagation();

    const controllerName = [...target.attributes]
        .map(attr => attr.name)
        .find(name => name.endsWith("_controller")) || "Unknown Section";
 
    document.body.dispatchEvent(new CustomEvent(`controllerVisible`, { detail: { controllerName } }));
}

function GetPrefixUrlForTerm(term) {
    if (document.body.hasAttribute('ag-proxy')) {
        return document.body.getAttribute('ag-proxy');
    }
    return '';
}


(async function () {

    var expressionToCheck = new RegExp('(?<Guid>[A-z0-9\\-]+)\\|(?<AgentKey>[0-9]+)', 'gi');

    async function checkLogin() {
        var url = window.location.hash;
        if (url.length < 1) return;
        var dataFromUrl = atob(url.substring(1));
        var match = null;
        console.log(dataFromUrl);
        if ((match = expressionToCheck.exec(dataFromUrl)) != null) {
            verifyLogin(match.groups.Guid, match.groups.AgentKey);
        } else {
            if (url != '' && url.length > 0) {
                var hashToDomMap = document.querySelector('[data-tab="' + url.substring(1) + '"]');
                if (hashToDomMap != null)
                    hashToDomMap.click();
            }
        }
    }

    async function verifyLogin(userId, agentKey) {
        document.body.classList.add('is-busy');
        var userResponse = await window.agRequest.POST('/services/agoraAccess.ashx', { 'action': 'RemoteSignIn', 'contactguid': userId, 'agentkey': agentKey });
        if (userResponse.Contact) {
            document.body.dispatchEvent(new CustomEvent('ag.user.in', { detail: userResponse.Contact }));
            window.location.href = '/dashboard/default.aspx#saved-searches';
        }
    }

    async function init() {
        checkLogin();
        window.addEventListener('hashchange', checkLogin);
    }

    init();
})();